/*
Compile with npm run dev
Navigate to http://localhost:8081/index.html   (ensure service/public is running)
*/

function simpleDateFormat(e, t) { this.locale = t && (t == "es_US" || t == "en_CA" || t == "fr_CA" || t == "en_GB" || t == "en_AU") ? t : "en_US"; this.applyPattern = function (e) { this.pattern = e || (this.locale == "en_CA" || this.locale == "fr_CA" || this.locale == "en_GB" || this.locale == "en_AU" ? "d/M/yy" : "M/d/yy") }; this.applyPattern(e); this.format = function (e) { e = e || new Date; if (!(e instanceof Date)) { var n = e.split("T")[0].split("-"), r = e.split("T").length > 1 ? e.split("T")[1].split(".")[0].split("Z")[0].split("-")[0].split(":") : ["00", "00", "00"]; e = new Date(n[0], n[1] - 1, n[2], r[0], r[1], r[2]) } var i = function (e) { e = "" + e; return e.indexOf("0") == 0 && e != "0" ? e.substring(1) : e }, s = function (e) { e = Number(e); return isNaN(e) ? "00" : (e < 10 ? "0" : "") + e }, o = { month: s(e.getMonth() + 1), date: s(e.getDate()), year: s(e.getFullYear()), day: e.getDay(), hour24: e.getHours(), hour12: e.getHours(), minutes: s(e.getMinutes()), ampm: "AM" }; if (o.hour24 > 11) { o.ampm = "PM" } o.hour24 = s(o.hour24); if (o.hour12 == 0) { o.hour12 = 12 } if (o.hour12 > 12) { o.hour12 = o.hour12 - 12 } o.hour12 = s(o.hour12); var u, a = function (e) { var n = e.replace(/yy+(?=y)/g, "yy").replace(/MMM+(?=M)/g, "MMM").replace(/d+(?=d)/g, "d").replace(/EEE+(?=E)/g, "EEE").replace(/a+(?=a)/g, "").replace(/k+(?=k)/g, "k").replace(/h+(?=h)/g, "h").replace(/m+(?=m)/g, "m"), r = n.replace(/yyy/g, o.year).replace(/yy/g, o.year.substring(2)).replace(/y/g, o.year).replace(/dd/g, o.date).replace(/d/g, i(o.date)), u = function (e, t, n) { for (var r = 1; r < e.length; r++) { if (!isNaN(e[r].substring(0, 1))) { var i = e[r].substring(0, 2); e[r] = e[r].substring(2); if (isNaN(i.substring(1))) { e[r] = i.substring(1) + e[r]; i = i.substring(0, 1) } i = Number(i); if (i > 23) { i = 23 } var u = n == "+" ? i : 0 - i; if (t == "kk" || t == "k") { u = Number(o.hour24) + u; if (u > 24) { u = u - 24 } else if (u < 0) { u = u + 24 } } else { u = Number(o.hour12) + u; if (u > 24) { u = u - 24 } else if (u < 0) { u = u + 24 } if (u > 12) { u = u - 12 } } u = "" + u; if (t == "kk" || t == "hh") { u = s(u) } if (t == "h" && u == 0 || t == "hh" && u == "00") { u = "12" } e[r] = u + e[r] } } return e.join("") }; if (r.indexOf("k+") != -1) { r = u(r.split("kk+"), "kk", "+"); r = u(r.split("k+"), "k", "+") } if (r.indexOf("k-") != -1) { r = u(r.split("kk-"), "kk", "-"); r = u(r.split("k-"), "k", "-") } r = r.replace(/kk/g, o.hour24).replace(/k/g, i(o.hour24)); if (r.indexOf("h+") != -1) { r = u(r.split("hh+"), "hh", "+"); r = u(r.split("h+"), "h", "+") } if (r.indexOf("h-") != -1) { r = u(r.split("hh-"), "hh", "-"); r = u(r.split("h-"), "h", "-") } r = r.replace(/hh/g, o.hour12 < 12 && o.hour12.indexOf && o.hour12.indexOf("0") != 0 ? "0" + o.hour12 : o.hour12).replace(/h/g, i(o.hour12)); r = r.replace(/mm/g, o.minutes).replace(/m/g, i(o.minutes)); r = r.replace(/a/g, "A"); var a = ["January", "February", "march", "april", "may", "June", "July", "august", "September", "October", "November", "December"]; if (t == "es_US") { a = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"] } if (t == "fr_CA") { a = ["janvier", "f&" + "#233;vrier", "mars", "avril", "mai", "juin", "juillet", "ao&" + "#251;t", "septembre", "octobre", "novembre", "d&" + "#233;cembre"] } r = r.replace(/MMMM/g, a[Number(o.month) - 1]).replace(/MMM/g, a[Number(o.month) - 1].substring(0, 3)).replace(/MM/g, o.month).replace(/M/g, i(o.month)).replace(/march/g, "March").replace(/mar/g, "Mar").replace(/may/g, "May").replace(/Mayo/g, "mayo"); var f = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]; if (t == "es_US") { f = ["domingo", "lunes", "martes", "mi&" + "eacute;rcoles", "jueves", "viernes", "s&" + "aacute;bado"] } if (t == "fr_CA") { f = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"] } r = r.replace(/EEEE/g, f[o.day]).replace(/EEE/g, f[o.day].substring(0, 3)).replace(/EE/g, f[o.day].substring(0, 3)).replace(/E/g, f[o.day].substring(0, 3)); r = r.replace(/A/g, o.ampm).replace(/april/g, "April").replace(/apr/g, "Apr").replace(/august/g, "August").replace(/aug/g, "Aug"); return r }; if (this.pattern.indexOf("'") == -1) { u = a(this.pattern) } else { var f = this.pattern.replace(/\'+(?=\')/g, "''").split("''"); if (f.length == 1) { f = this.pattern.split("'"); for (var l = 0; l < f.length; l++) { if (l % 2 == 0) { f[l] = a(f[l]) } } return f.join("") } else { for (var l = 0; l < f.length; l++) { var c = f[l].split("'"); for (var h = 0; h < c.length; h++) { if (h % 2 == 0) { c[h] = a(c[h]) } } f[l] = c.join("") } return f.join("'") } } return u } }

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

declare var Highcharts: any;
declare var jQuery: any;
class AnnouncementTableOptions {
  announcementDateFormat: string;
  hidePriceSensitive: boolean; 
  numAnnouncements: number;  
}

interface IApiKeyWrapper {
  apiKey:string
  marketData?:StockMarketData
  announcements?:Announcement[]
  chartData?:StockData[]
  secFilingResult?:ISecFilingResult
  subscriptionExpired?:boolean
}
interface AnnouncementFilterOptions {
  priceSensitiveOnly:boolean;
  filterRegex:string;
  maxYears:number;
  startYear:number;    
}

interface ISecFilingResult{
  secFilings:SecFiling[]
}
interface SecFiling{
  date:string
  form:string
  description:string
  files:SecFilingDocument[]
}
interface SecFilingDocument{
  secFilingDocumentType: SecFilingDocumentType
  url:string
}
enum SecFilingDocumentType {
  None,
  Html,  
  Zip,
  Pdf,
  Xml
}
type InputType = 'textarea' | 'text' | 'email' | 'checkbox';

type CommentsWordingType = 'comment' | 'question';

interface SearchBoxOptions {
  getTextFunc?:(row:HTMLElement)=>string
  onkeyup?:(ev:KeyboardEvent)=>void
}

interface IWidgetElement<T> extends HTMLElement{
  investi:T
}

interface AnnouncementsInteractiveWidgetElement extends IWidgetElement<AnnouncementsInteractiveWidgetData> {
  
} 

interface AnnouncementsInteractiveWidgetData {  
  announcements:Announcement[]
  selected?:Announcement
  selectedElem?:HTMLElement
  page:number
  apiKey:string
  noComments: boolean
  commentsWordingType:CommentsWordingType
}

interface AnnouncementCommentRequest {
    apiKey: string;
    announcementGuid: string;
    name: string;
    email: string;
    comment: string;
    isPrivate:boolean
    locationHref:string
}

interface AnnouncementCommentResult {
    errorMessage: string;
}


interface AnnouncementCommentsResult {
    comments: AnnouncementCommentApi[];
    errorMessage: string;
}

interface AnnouncementCommentApi {
    name: string;
    comment: string;
    responses: AnnouncementCommentApi[];
    date: string;
}


const SharePriceWidgetName = 'investi-share-price';
const HeaderPriceWidgetName = 'investi-header-price-widget';
const HeaderPriceWidgetNamev2 = 'investi-header-price';
const PriceOnTopWidgetName = 'investi-price-on-top-widget';

const SharePriceLastElementName = 'investi-share-price-last';
const SharePriceSymbolElementName = 'investi-share-price-symbol';
const SharePriceVolumeElementName = 'investi-share-price-volume';
const SharePriceLow52WeekElementName = 'investi-share-price-low52Week';
const SharePriceLowElementName = 'investi-share-price-low';
const SharePriceAskElementName = 'investi-share-price-ask';
const SharePricePrevCloseElementName = 'investi-share-price-prevClose';
const SharePriceOpenElementName = 'investi-share-price-open';
const SharePriceHigh52WeekElementName = 'investi-share-price-high52Week';
const SharePriceHighElementName = 'investi-share-price-high';
const SharePriceBidElementName = 'investi-share-price-bid';
const SharePriceMovement = 'investi-share-price-movement';
const SharePriceMovementPercent = 'investi-share-price-movement-percent';
const ShareMarketCapName = 'investi-market-cap';
const SharesOnIssueName = 'investi-shares-on-issue';
const SharePriceUpdateTime = 'investi-share-price-update-time';
const SharePriceUpdateDate = 'investi-share-price-update-date';
const SharePriceUpdated = 'investi-share-price-updated';
const SharePriceTable = 'investi-share-price-table';

const SharePriceChartWidgetName = 'investi-share-price-chart';

const AnnouncementsWidgetName = 'investi-announcements';
const AnnouncementsSummaryWidgetName = 'investi-announcements-summary';
const AnnouncementsSummaryv2WidgetName = 'investi-announcements-summary-v2';
const AnnouncementsAccordionWidgetName = 'investi-announcements-accordion';
const AnnouncementsTabWidgetName = 'investi-announcements-tab';
const AnnouncementsCarouselWidgetName = 'investi-carousel';
const AnnouncementsInteractiveWidgetName = 'investi-interactive-announcements';
const AnnouncementsLatestPresentationWidgetName = 'investi-latest-presentation';
const AnnouncementsReportsWidgetName = 'investi-reports';
const AnnouncementsThumbnailWidgetName = 'investi-announcements-thumbnail';

const MovementUnchangedTextAttrName:string = 'data-investi-movement-unchanged-text'

const AnnouncementDataWidgetNames:string[] = [ 
  AnnouncementsWidgetName,
  AnnouncementsSummaryWidgetName,
  AnnouncementsSummaryv2WidgetName,
  AnnouncementsAccordionWidgetName,
  AnnouncementsTabWidgetName,
  AnnouncementsCarouselWidgetName,
  AnnouncementsInteractiveWidgetName,
  AnnouncementsLatestPresentationWidgetName,
  AnnouncementsReportsWidgetName,
  AnnouncementsThumbnailWidgetName
];

const MarketDataElemNames:string[] = [
  SharePriceLastElementName, 
  SharePriceMovement, 
  SharePriceMovementPercent, 
  ShareMarketCapName, 
  SharesOnIssueName, 
  SharePriceUpdateTime, 
  SharePriceUpdateDate,
  SharePriceSymbolElementName,
  SharePriceVolumeElementName,
  SharePriceLow52WeekElementName,
  SharePriceLowElementName,
  SharePriceAskElementName,
  SharePricePrevCloseElementName,
  SharePriceOpenElementName,
  SharePriceHigh52WeekElementName,
  SharePriceHighElementName,
  SharePriceBidElementName,
  SharePriceUpdated  
]

const RequiresMarketDataNames:string[] = [ 
  ...MarketDataElemNames,
  SharePriceWidgetName,
  HeaderPriceWidgetName,
  PriceOnTopWidgetName,
  SharePriceTable,
  SharePriceChartWidgetName //required to get the ticker or header
];


const SecFilingsWidgetName = 'investi-sec-filings';

const WidgetCreatedAttrName:string = 'data-investi-widget-created';

const SubscriptionExpiredMessage = 'Investi subscription expired. Contact Investi Support contact@investi.com.au'

class InvestiWidget {
  
  baseAddress: string = "";
  apiKeys: IApiKeyWrapper[] = [];  
  activatedClassName:string = 'investi-announcements-accordion-year-activated';      
  pdfViewer:PdfViewer;

  constructor() {        
    
    this.apiKeys = this.getApiKeys();
    
    
    let currentScriptSrc = (document.currentScript as any).src || '';
    if(process.env.NODE_ENV === "development"){      
      // this.baseAddress = "http://localhost:5000";
      this.baseAddress = "https://api.investi.com.au";
    }else if(currentScriptSrc.includes('dev.investi.com.au')){      
      this.baseAddress = new URL(currentScriptSrc).origin;
    }else if (!currentScriptSrc.includes('investi.com.au')) {
      this.baseAddress = "".concat(window.location.protocol, "//").concat("api.investi.com.au");
    } 
    else{
      const url = new URL(currentScriptSrc);
      this.baseAddress = `${window.location.protocol}//${url.host}`;  
    }   
    console.log(`using baseAddress: ${this.baseAddress}`)

  }

  getApiKeys() : IApiKeyWrapper[]{
    const apiKey = this.getParam('apiKey'); 
    let arr = [];
    if(apiKey){      
      arr = apiKey.split(',').map(value => value.trim());;    
    } 

    // Select all elements with 'investi' in their id or class
    const allInvestiElements = [
      ...Array.from(document.querySelectorAll('[id^="investi"]')),
      ...Array.from(document.querySelectorAll('[class^="investi"]'))
    ];

    // Loop through the elements and add apiKey values
    allInvestiElements.forEach(element => {
      let apiKeyAttr = element.getAttribute('apikey');
      if (apiKeyAttr) {
        let trimmedApiKey = apiKeyAttr.trim();
        if (!arr.includes(trimmedApiKey)) {
          arr.push(trimmedApiKey);
        }
      }
    });

    
    return arr.map(x=> ({ apiKey: x, ticker: '' }));     


  }

  createInvestiSharePriceWidget(elemId?: string) {

    if(elemId){
      //not sure who uses this but we have to support passing in the elemId
      let elem: HTMLElement = document.getElementById(elemId);
      elem.innerHTML = this.getSharePriceWidgetHTML();
      const apiKey = elem.getAttribute('apiKey');
      this.getMarketData(apiKey, data => {
        this.setInvestiSharePriceWidget(data, elem);
      });
    }else{
      
      this.doActionOnIdOrClass(SharePriceWidgetName, (elem, apiKey) => {
        elem.innerHTML = this.getSharePriceWidgetHTML();
        this.getMarketData(apiKey, data => {
          this.setInvestiSharePriceWidget(data, elem);
        });
      });      
    }
  }


  getSharePriceWidgetHTML(){
    return `<div class="market-data-header">LATEST SHARE PRICE</div>
    <div class="market-data-header"><span class="investi-stock-exchange"></span>:<span id="market-data-ticker">
       </span>
    </div>
    <div class="investi-market-data-last-container"> <span id="market-data-last"></span> </div>
    <div class="market-data-movement-section">
       <span id="market-data-movement"></span><span id="market-data-movementPercent"></span>
    </div>
    <div class="market-data-updated-section">
       <table>
          <tbody>
             <tr>
                <td>UPDATED</td>
                <td><span id="market-data-updated"></span></td>
             </tr>
             <tr>
                <td>EXCHANGE</td>
                <td><span class="investi-stock-exchange"></span></td>
             </tr>
             <tr>
                <td>CURRENCY</td>
                <td><span class="investi-stock-currency"></span></td>
             </tr>
          </tbody>
       </table>
    </div>
     `;
  }

  shouldPollMarketData() : boolean {
    
    for (let elem of RequiresMarketDataNames) {
      if (document.getElementById(elem) != null){        
        return true;
      }
      if (document.getElementsByClassName(elem).length > 0){        
        return true;
      }        
    }
    return false;
  }

  hasAnnouncementWidget() : boolean {
    
    for (let elem of AnnouncementDataWidgetNames) {
      if (document.getElementById(elem) != null){        
        return true;
      }
      if (document.getElementsByClassName(elem).length > 0){        
        return true;
      }        
    }
    return false;
  }

  ensureContainer(apiKey:string|null) {
    apiKey = apiKey || this.apiKeys[0].apiKey;
    let container = this.apiKeys.find(x=>x.apiKey===apiKey);
    if(!container){
      console.warn(`apiKey not defined in url. will still work but is less efficient`)
      container = { apiKey };
      this.apiKeys.push(container);
    }
    return container;
  }
  
  getMarketData(apiKey:string|null, callback:(wrapper:IApiKeyWrapper)=>void, onError?:(e:any)=>void) {
    const container = this.ensureContainer(apiKey);
    if (!container.marketData) {
      // console.log(`sendRequest market data`, apiKey)
      this.sendRequest('/api/marketdata', apiKey,
        json => {               
          this.setContainerField(container, json, x =>container.marketData = x)
          callback(container);
        },
        onError);
    } else {
      //console.log(`using cached market data`, container.marketData)
      callback(container);
    }    
  }

  setContainerField(container:IApiKeyWrapper, json:string, setter:(obj:any)=>void){
    const deserialized = JSON.parse(json);
    if(this.isSubscriptionExpired(deserialized)){
      console.warn(`subscription has expired`)
      container.subscriptionExpired = true;
    }else{
      setter(deserialized)
    }
    
  }

  isSubscriptionExpired(deserialized:any){
    return deserialized["subscriptionExpired"] === true;
  }

  getAnnouncementData(apiKey:string|null, callback:(wrapper:IApiKeyWrapper)=>void, onError?:(e:any)=>void) {
    const container = this.ensureContainer(apiKey);
    if (!container.announcements) {      
      this.sendRequest('/api/announcements', apiKey,
        json => {                     
          const setter = x => {
            for(let announcement of x){                            
              if(announcement.videoUrl === undefined){
                announcement["videoUrl"] = '';
              } 
              if(announcement.videoDescription === undefined){
                announcement["videoDescription"] = '';
              }              
            }

            container.announcements = x
          };
          this.setContainerField(container, json, setter)
          callback(container);
        },
        onError);
    } else {      
      callback(container);
    }    
  }

  getDollarSign(currency:string){
    if(currency == 'GBP')
      return '£'
    if(currency == 'AUD')
      return '$'
    if(currency == 'EUR')
      return '€'
    return '';
  }

  setInvestiSharePriceWidget(container:IApiKeyWrapper, elem: HTMLElement,  dollarSign?:string) {    
    if(this.checkSubscriptionExpired(elem, container))
      return;

    const data:StockMarketData = container.marketData
    let date = new Date(data.updated);
    
    if(elem != null){
      dollarSign = dollarSign || this.getDollarSign(data.currency);
      
      this.setElementWithData('market-data-last', `<span class="market-data-last-dollar-sign">${dollarSign}</span>` + this.addZeroes(data.last, elem), elem);  

      let movementElem = elem.querySelector('#market-data-movement');    
      let movementPercentElem = elem.querySelector('#market-data-movementPercent');
      if (movementElem != null && movementPercentElem != null)
        this.setMovementElem(data, movementElem, movementPercentElem, elem);
      
      //var updated = moment(data.updated).format('DD MMM HH:mm') + ' - ' + moment(data.currentMarketData.updated).fromNow();
      
      var updated = this.formatDate(date);
      this.setElementWithData('market-data-updated', updated, elem);
      this.setElementWithData('market-data-ticker', data.ticker, elem);
      for (let exchangeElem of <any>elem.getElementsByClassName('investi-stock-exchange')) {
        exchangeElem.innerText = data.exchange;
      }    
      for (let exchangeElem of <any>elem.getElementsByClassName('investi-stock-currency')) {
        exchangeElem.innerText = data.currency;
      }      

    }else{
      let movementElem = document.querySelector<HTMLElement>('#market-data-movement');    
      let movementPercentElem = document.querySelector('#market-data-movementPercent');
      if (movementElem != null && movementPercentElem != null)
        this.setMovementElem(data, movementElem, movementPercentElem, movementElem);      
    }
    
  }

  setMarketCap(elem:HTMLElement, data:StockMarketData) {   
    
    if(elem != null){
      let suffix = "M";
      let amt = Math.round(data.marketCap / 1000000)
      if(amt > 1000){        
        amt = parseFloat((amt / 1000).toFixed(1))
        suffix = "B";
      }            
      
      var amountElement: HTMLElement = document.createElement('span');
      amountElement.className = 'investi-market-cap-amount'
      amountElement.innerText = amt.toLocaleString();
      elem.append(amountElement)

      var suffixElement: HTMLElement = document.createElement('span');
      suffixElement.className = 'investi-market-cap-suffix'
      suffixElement.innerText = suffix;
      elem.append(suffixElement)
    }
  }

  setMarketDataFieldWithCommas(elem:HTMLElement, field:number) {   
    if(elem != null){      
      elem.innerText = field.toLocaleString();
    }
  }

  setSharePriceMovementPercent(elem:HTMLElement, movementPercent:number) {   
    
    if(elem != null){
      let prefix = '';
      let className = 'investi-movement-percent-no-movement';
      if(movementPercent > 0){
        prefix = '+';
        className = 'investi-movement-percent-up';
      }else if(movementPercent < 0){
        prefix = '-';
        className = 'investi-movement-percent-down';
      }            
      elem.className = className;

      var plusminusSpan: HTMLElement = document.createElement('span');
      plusminusSpan.className = "investi-share-price-movement-percent-plusminus";
      plusminusSpan.innerText = prefix;
      elem.append(plusminusSpan);

      const textSpan: HTMLElement = document.createElement('span');
      textSpan.className = "investi-share-price-movement-percent-text";      
      textSpan.innerText = this.getFormattedMarketDataNumericField(Math.abs(movementPercent), elem)
      elem.append(textSpan);
    } 
  }

  setSharePriceMovement(elem:HTMLElement, data:StockMarketData) {        
        
    let className = 'investi-movement-no-movement'; 
    if(elem){
      const movement:number = data.movement;
      let prefix = '';
      if(movement > 0){
        prefix = '+';
        className = 'movement-up';
      }else if(movement < 0){
        prefix = '-';
        className = 'movement-down';
      }
            
      elem.className = className;

      const plusminusSpan: HTMLElement = document.createElement('span');
      plusminusSpan.className = "investi-share-price-movement-plusminus";
      plusminusSpan.innerText = prefix;
      elem.append(plusminusSpan);

      const textSpan: HTMLElement = document.createElement('span');
      textSpan.className = "investi-share-price-movement-text";
      const unchangedText = elem.getAttribute(MovementUnchangedTextAttrName);      
      const movementText = (movement == 0 && unchangedText) ? unchangedText : this.addZeroes(Math.abs(movement), elem);            
      textSpan.innerText = this.getDollarSign(data.currency) + movementText
      elem.append(textSpan);

      
    }
    
  }
  //https://stackoverflow.com/a/24039448/224410
  addZeroes(num:any, elem:HTMLElement) :any{
    
    if(num==0){      
      return this.getFormattedMarketDataNumericField(num, elem);
    }
      
    num = num+'';
    // Convert input string to a number and store as a variable.
    var value:any = Number(num);
    // Split the input string into two arrays containing integers/decimals
    var res = num.split(".");
    // If there is no decimal point or only one decimal place found.
    if (res.length == 1 || res[1].length < 3) {
      // Set the number to two decimal places or more if explicitly defined
      value = this.getFormattedMarketDataNumericField(value, elem);
    }
    // Return updated or original number.
    return value;
  }

  setElementWithData(elemId:string, data:string, parent?: HTMLElement) {        
    let elem = parent != null ? parent.querySelector('#'+elemId) : document.getElementById(elemId);
    
    if(elem)
      elem.innerHTML = data;
  }
  
  setMovementElem(data, movementElem, movementPercentElem, widget:HTMLElement) {
    const unchangedText = widget.getAttribute(MovementUnchangedTextAttrName);
    let movementStr = data.movement;
    let movementColorClass = '';
    if (data.movement > 0) {
      movementStr = "+" + movementStr;
      movementColorClass = 'movement-up';
    }
    else if (data.movement < 0) {
      movementColorClass = 'movement-down';
    }
    else{      
      movementColorClass = 'movement-unchanged';
      if(data.movement == 0 && unchangedText){
        movementStr = unchangedText;
      }
    }
    
    movementElem.innerHTML = movementStr;
    movementElem.className += ' ' + movementColorClass;
    const movementPercent = this.getFormattedMarketDataNumericField(data.movementPercent, movementElem)

    movementPercentElem.innerHTML = movementPercent + '%';
    movementPercentElem.className += ' ' + movementColorClass;
  }

async sendRequest(route: string, apiKey: string, callback: (response: string) => void, onError?:(e:any)=>void) {
  const maxAttempts = 3;
  const delayMs = 200;

  apiKey = apiKey || (this.apiKeys.length ? this.apiKeys[0].apiKey : null);
  if (!apiKey) throw new Error('apiKey must be defined.');

  const url = this.buildUrl(route, apiKey);

  const attemptRequest = async (attempt: number): Promise<void> => {
    try {
      const response = await fetch(url);
      if (response.ok) {
        const data = await response.text();
        callback(data);
      } else {
        throw new Error(`HTTP ${response.status}`);
      }
    } catch (err) {
      console.warn(`Attempt ${attempt} failed: ${err}`);
      if (attempt < maxAttempts) {
        await this.delay(delayMs);
        return attemptRequest(attempt + 1);
      } else {
        const err = `sendRequest failed after ${maxAttempts} attempts for apiKey:${apiKey}`;
        if(onError){
          onError(err);
        }else{
          console.warn(err)
        }
      }
    }
  };

  await attemptRequest(1);
}

buildUrl(route: string, apiKey: string): string {
  const separator = route.includes('?') ? '&' : '?';
  return `${this.baseAddress}${route}${separator}apiKey=${apiKey}`;
}

delay(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}


  getParam(name:string):string {
    let elements = document.getElementsByTagName('script');
    for (let i = 0; elements[i]; i++) {
      var srcAttr: string = elements[i].getAttribute('src');            
	  if (srcAttr && /investi\.js/.test(srcAttr)) {
        return this.getParameterByName(name, srcAttr);
      }     
    }
    return null;
  }

  getParameterByName(name, url):string {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
  monthNames:string[] = [
    "Jan", "Feb", "Mar",
    "Apr", "May", "Jun", "Jul",
    "Aug", "Sep", "Oct",
    "Nov", "Dec"
  ];
  formatDate(date) {
    

    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();

    return day + ' ' + this.monthNames[monthIndex] + ' ' + this.formatAMPM(date);
  }
  formatDateOnly(date) {
    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();
    return day + ' ' + this.monthNames[monthIndex] + ' ' + year;
  }

  formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  createInvestiChart() {
    this.doActionOnIdOrClass(SharePriceChartWidgetName, (elem, apiKey) => {
      
      this.getChartData(apiKey, (container:IApiKeyWrapper) => {
        this.createChart(elem, container);
      });
    });     
  }

  createInvestiSharePriceTable() {
    this.doActionOnIdOrClass(SharePriceTable, (elem, apiKey) => {
      
      this.getMarketData(apiKey, data => {
        this.createSharePriceTable(elem, data);        
      }); 
    });     
  }

  checkSubscriptionExpired(elem: HTMLElement, container:IApiKeyWrapper) : boolean {
    if(container.subscriptionExpired === true){
      elem.innerText = SubscriptionExpiredMessage;
      return true;
    }
    return false;
  }

  createSharePriceTable(elem: HTMLElement, container:IApiKeyWrapper) {    
    
    if(this.checkSubscriptionExpired(elem, container))
      return;
    
    const data:StockMarketData = container.marketData;
    const apiKey = elem.getAttribute('apiKey') || '';
    const attrVal = elem.getAttribute('investi-num-decimal-places');
    let dpAttr = '';
    if(parseInt(attrVal)){
      dpAttr = `investi-num-decimal-places="${attrVal}"`;
    }
    
    
    elem.innerHTML = `<div class="investi-market-data-container">
    <div class="investi-market-data-field-name">Symbol: </div>
    <div class="investi-share-price-symbol" apiKey="${apiKey}"></div>
    <div class="investi-market-data-field-name">Share Price: </div>
    <div class="investi-share-price-last" data-investi-prefix-currency-symbol apiKey="${apiKey}"></div>
    <div class="investi-market-data-field-name">Market Cap: $</div>
    <div class="investi-market-cap" apiKey="${apiKey}"></div>
    <div class="investi-market-data-field-name">Shares on Issue: </div>
    <div class="investi-shares-on-issue" apiKey="${apiKey}"></div>
    <div class="investi-market-data-field-name">% Change: </div>
    <div class="investi-share-price-movement-percent" apiKey="${apiKey}"></div>
  
    <div class="investi-market-data-field-name">${this.getDollarSign(data.currency)} Change: </div>
    <div class="investi-share-price-movement" apiKey="${apiKey}" ${dpAttr}></div>
    <div class="investi-market-data-field-name">Volume: </div>
    <div class="investi-share-price-volume" apiKey="${apiKey}"></div>
    <div class="investi-market-data-field-name">Prev Close: </div>
    <div class="investi-share-price-prevClose" apiKey="${apiKey}" ${dpAttr}></div>
  
    <div class="investi-market-data-field-name">Low: </div>
    <div class="investi-share-price-low" apiKey="${apiKey}" ${dpAttr}></div>
    <div class="investi-market-data-field-name">52 Week Low: </div>
    <div class="investi-share-price-low52Week" apiKey="${apiKey}" ${dpAttr}></div>
    <div class="investi-market-data-field-name">High: </div>
    <div class="investi-share-price-high" apiKey="${apiKey}" ${dpAttr}></div>
    <div class="investi-market-data-field-name">52 Week High: </div>
    <div class="investi-share-price-high52Week" apiKey="${apiKey}" ${dpAttr}></div>
    <div class="investi-market-data-field-name">Ask: </div>
    <div class="investi-share-price-ask" apiKey="${apiKey}" ${dpAttr}></div>
  
    <div class="investi-market-data-field-name">Open: </div>
    <div class="investi-share-price-open" apiKey="${apiKey}" ${dpAttr}></div>
  
    <div class="investi-market-data-field-name">Bid: </div>
    <div class="investi-share-price-bid" apiKey="${apiKey}" ${dpAttr}></div>
    <div class="investi-market-data-field-name">Updated:</div>
    <div class="investi-share-price-updated" apiKey="${apiKey}"></div>
  
  </div>
  
  <div class="investi-market-data-delayed-info">Market Data prices are at least 20 minutes delayed</div>
  

  `  

  }

  getChartData(apiKey:string|null, callback:(wrapper:IApiKeyWrapper)=>void) {
    const container = this.ensureContainer(apiKey);
    const handler = () => {
      callback(container);
    }
    if (!container.chartData) {      
      this.sendRequest('/api/chartdata', apiKey,
        json => {          
          this.setContainerField(container, json, x =>container.chartData = x)
          handler();
        });
    } else {      
      handler();
    }    
  }

  createChart(elem:HTMLElement, container:IApiKeyWrapper){
    if(this.checkSubscriptionExpired(elem, container))
      return;
    const data:StockData[] = container.chartData;
      var color:string = elem.getAttribute('data-investi-chart-theme-color-hex');
      var yAxisColor:string = elem.getAttribute('data-investi-chart-theme-yAxisColor-hex');
      var xAxisColor:string = elem.getAttribute('data-investi-chart-theme-xAxisColor-hex');
      var rangeSelected:string = elem.getAttribute('data-investi-chart-range-selected');
      const showChartHeader:boolean = elem.getAttribute('data-investi-chart-header')?.toLowerCase() === "true";

      
      this.waitForHighcharts(10, 200)
    .then(() => {
      this.makeChart(elem, data, container.marketData, color, yAxisColor, xAxisColor, parseInt(rangeSelected),showChartHeader);
    })
    .catch((error) => {
        console.error(error);
        // Handle the error (e.g., display a user-friendly message)
    });
      
  }

  waitForHighcharts(maxAttempts:number, interval:number) {
    return new Promise<void>((resolve, reject) => {
        let attempts = 0;

        const checkHighcharts = () => {
            if (typeof Highcharts !== "undefined") {
                resolve();
            } else if (attempts < maxAttempts) {
                attempts++;
                console.log(`Highcharts is undefined. attempt:${attempts}`)
                setTimeout(checkHighcharts, interval);                
            } else {
                reject(new Error("Highcharts is not defined. You need to add <script src=\"//code.highcharts.com/stock/11.1.0/highstock.js\"></script>"));
            }
        };

        checkHighcharts();
    });
}

  
  getChartRangeSelectorButtons(attrVal:string) : {}[] {
  

    const parts = attrVal.split(',');
    const buttons = parts.map(part => {
      const text = part;
      let type, count;

      if (part === 'YTD') {
          type = 'ytd';
      } else if (part === 'All') {
          type = 'all';
      } else {
          const match = part.match(/(\d+)([a-z]+)/); // Extract number and unit
          if (match) {
              count = parseInt(match[1], 10);
              const unit = match[2];

              // Map units to Highcharts types
              if (unit === 'm') {
                  type = 'month';
              } else if (unit === 'y') {
                  type = 'year';
              }
          }
      }

      return { type, count, text };
    });
    return buttons;
  }

  makeChart(elem:HTMLElement, data:StockData[], marketData:StockMarketData, color:string, yAxisColor?:string, xAxisColor?:string, rangeSelected?:number, showChartHeader?:boolean) {
    
    
    let headerDiv:HTMLElement | undefined;

    if (showChartHeader) {
      

      headerDiv = document.createElement('div');
      headerDiv.className = "investi-share-price-chart-header";
      this.setChartHeaderElem(headerDiv, marketData);                  
      
      elem.insertBefore(headerDiv, elem.firstChild);
      
      
      let containerElem = elem;
      containerElem.classList.remove(SharePriceChartWidgetName);
      containerElem.classList.add("investi-share-price-chart-container");

      elem = document.createElement('div');
      elem.classList.add(SharePriceChartWidgetName);
      containerElem.append(elem);
    }
    
    const buttonsAttr = elem.getAttribute('data-investi-range-selector-buttons') || undefined;  
    const ticker = `${marketData?.ticker}:${marketData?.exchange}`
    Highcharts.stockChart(elem, this.getChartOptions(data, color, ticker, yAxisColor, xAxisColor, rangeSelected, buttonsAttr ));
    
  }

  getChartOptions(data:StockData[], color:string, ticker:string, yAxisColor?:string, xAxisColor?:string, rangeSelected?:number, buttonsAttr?:any) : any {

    
    // create the chart
    let defaultColor = color || '#000000';  
    let defaultAxisColor = '#D3D3D3';
    let defaultAxisTextColor = '#000';
    
    // split the data set into ohlc and volume
    var seriesData = [],
      volume = [],
      dataLength = data.length,
      i = 0;

    for (i; i < dataLength; i += 1) {
      var jsDate = new Date(data[i].date.substring(0, 10));
      var dateMs = Math.round(jsDate.getTime());
      seriesData.push([
        dateMs, // the date
        data[i].close
      ]);

      volume.push([
        dateMs, // the date
        data[i].volume // the volume
      ]);
    }

    const options = {

      
      credits: { enabled: false },
    
      chart: {
        alignTicks: false,
        backgroundColor: null,
        style: {
          fontFamily: 'Segoe UI, Roboto, sans-serif',
          fontSize: '13px'
        },
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        
      },
    
      title: { text: '', style: { color: defaultColor } },
      subtitle: { style: { color: xAxisColor || defaultColor, fontSize: '12px' } },
    
      rangeSelector: {
        selected: isNaN(rangeSelected) ? 4 : rangeSelected,
        inputEnabled: false,
        ...(typeof buttonsAttr !== 'undefined' && {
          buttons: this.getChartRangeSelectorButtons(buttonsAttr)
        }),
        buttonTheme: {
          width: 40,
          style: {
            textDecoration: 'none',
            fontSize: '12px' // adjust this to desired size
          },
          states: {
            select: {
              style: {
                fontWeight: 'bold',                
                color: defaultColor
              }
            },
            hover: {
              style: {
                color: defaultColor
              }
            }
          }
        },
        
        inputBoxBorderColor: 'transparent'
      },
    
      xAxis: [{
        lineColor: xAxisColor || defaultAxisColor,
        type: 'datetime',
        gridLineColor: '#D3D3D3',
        gridLineWidth: 1,
        gridLineDashStyle: 'Dash',
        crosshair: { color: defaultColor, dashStyle: 'ShortDot' },
        labels: { style: { color: xAxisColor || defaultAxisTextColor } }
      }],
    
      yAxis: [{
        lineColor: yAxisColor || defaultAxisColor,
        gridLineColor: '#D3D3D3',
        gridLineDashStyle: 'Dash',
        labels: { align: 'left', x: 3, style: { color: yAxisColor || defaultAxisTextColor }, reserveSpace: true, allowOverlap: false },
        title: { text: 'Price', style: { color: yAxisColor || defaultAxisTextColor, fontSize: '12px' } },
        height: '60%',
        lineWidth: 0
      }, {
        lineColor: yAxisColor || defaultAxisColor,
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        gridLineColor: 'transparent',
        gridLineDashStyle: 'Dash',
        labels: { align: 'left', x: 3, style: { color: yAxisColor || defaultAxisTextColor }, reserveSpace: true, allowOverlap: false },
        title: { text: 'Volume', style: { color: yAxisColor || defaultAxisTextColor, fontSize: '12px' } },
        top: '65%',
        height: '35%',
        offset: 0,
        lineWidth: 0
      }],
    
      tooltip: { xDateFormat: '%Y-%m-%d', split: true, shared: true },
      navigator: { enabled: false },
      plotOptions: {
        series: {
          dataGrouping: { enabled: false },
          states: { hover: { enabled: true, lineWidthPlus: 1 } },
          marker: {
            enabled: false,
            states: { hover: { enabled: true, radius: 4 } }
          }
        },
        area: {
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, Highcharts.color(defaultColor).setOpacity(0.3).get('rgba')], // 20% opacity
              [1, Highcharts.color(defaultColor).setOpacity(0.3).get('rgba')]  // same here
            ]
          },
          
          showInLegend: false
        }
      },
    
      series: [{
        name: ticker,
        type: 'area',
        data: seriesData,
        gapSize: 12,
        color: defaultColor,
        threshold: null,
        marker: {
          enabled: false,
          states: {
            hover: { enabled: true, radius: 4 }
          }
        }
      }, {
        type: 'column',
        name: 'Volume',
        data: volume,
        yAxis: 1,
        color: Highcharts.color(defaultColor).setOpacity(0.5).get('rgba')
      }]
    }
    return options;
  }

  setChartHeaderElem(headerDiv:HTMLElement, marketData:StockMarketData){

    const companyNameRow = document.createElement('div');
    companyNameRow.className = "investi-share-price-chart-header-company-name-row";

    const companyNameDiv = document.createElement('span');
    companyNameDiv.className = "investi-share-price-chart-header-company-name";
    companyNameDiv.innerText = marketData.companyName;

    const companyTickerDiv = document.createElement('span');
    companyTickerDiv.className = "investi-share-price-chart-header-company-ticker";

    companyTickerDiv.innerText = `(${marketData.ticker})`;
    companyNameRow.appendChild(companyNameDiv);
    companyNameRow.appendChild(companyTickerDiv);
    headerDiv.append(companyNameRow);


    const priceDivRow = document.createElement('div');
    priceDivRow.className = "investi-share-price-chart-header-price-row";

    let priceSpan = document.createElement('span');
    priceSpan.className = "investi-share-price-chart-header-last-price-elem";

    this.setPriceWidgetLastPriceDiv(priceSpan, this.addZeroes(marketData.last, priceSpan), marketData.currency);
    priceDivRow.append(priceSpan);

    const movementDiv = document.createElement('span');
    this.setSharePriceMovement(movementDiv, marketData);
    movementDiv.classList.add("investi-share-price-chart-header-movement-elem")

    priceDivRow.append(movementDiv);

    const movementPercentDiv = document.createElement('span');
    this.setSharePriceMovementPercent(movementPercentDiv, marketData.movementPercent);
    movementPercentDiv.classList.add("investi-share-price-chart-header-movement-percent-elem")
    priceDivRow.append(movementPercentDiv);

    const exchangeDiv = document.createElement('span');
    exchangeDiv.className = "investi-share-price-chart-header-exchange";

    const separatorElem = document.createElement('span');
    separatorElem.className = "investi-share-price-chart-header-exchange-separator";
    separatorElem.innerText = "  | ";
    exchangeDiv.append(separatorElem);

    const exchangeNameDiv = document.createElement('span');
    exchangeNameDiv.className = "investi-share-price-chart-header-exchange-name";
    exchangeNameDiv.innerText = marketData.exchange;
    exchangeDiv.append(exchangeNameDiv);

    const exchangeNameSuffixDiv = document.createElement('span');
    exchangeNameSuffixDiv.className = "investi-share-price-chart-header-exchange-suffix";
    exchangeNameSuffixDiv.innerText = " Exchange"
    exchangeDiv.append(exchangeNameSuffixDiv);

    priceDivRow.append(exchangeDiv);
    
    headerDiv.append(priceDivRow)
    // this.createPriceWidget(elems, marketData, true);
    
  
  
  }

  createInvestiAnnouncementTable() {
    
    this.doActionOnIdOrClass(AnnouncementsWidgetName, (elem, apiKey) => {
      
      this.getAnnouncementData(apiKey, container => {
        let announcements = container.announcements;
        if(this.checkSubscriptionExpired(elem, container))
          return;
        elem.innerHTML = '';      
        const options = new AnnouncementTableOptions();
        options.announcementDateFormat = this.getDateFormat(elem);
        options.hidePriceSensitive = elem.getAttribute('data-invest-hide-price-sensitive')==='true';
        if (elem.getAttribute('data-investi-num-announcements')){
          options.numAnnouncements = parseInt(elem.getAttribute('data-investi-num-announcements'));
        }
          
        announcements = this.filterAnnouncements(elem, announcements);
        this.setAnnouncementData(elem, announcements, options);
      });
    });
  }

  getDateFormat(elem:HTMLElement):string|undefined {
    return elem.getAttribute('data-investi-announcement-date-format') || elem.getAttribute('data-investi-date-format');
  }


  readonly InteractiveAnnouncementsRowHiddenClassName:string = 'investi-interactive-announcements-row-hidden';
  readonly InteractiveAnnouncementsHeadlineClassName:string = 'investi-interactive-announcements__headline';
  readonly InteractiveAnnouncementsPerPageDefault:number = 8;
  readonly PdfJsScriptSrc:string = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.2.67/pdf.min.mjs';

  createInvestiAnnouncementsInteractiveTable() {
    
    this.doActionOnIdOrClass(AnnouncementsInteractiveWidgetName, (e, apiKey) => {
      const elem = e as AnnouncementsInteractiveWidgetElement;
      this.getAnnouncementData(apiKey, container => {
        let announcements = container.announcements;
        if(this.checkSubscriptionExpired(elem, container))
          return;
        elem.innerHTML = '';
        const noComments = elem.hasAttribute('data-investi-no-comments');
        const commentsWordingType = this.getCommentsWordingType(elem);
        elem.investi = { announcements, page: 0, apiKey: container.apiKey, noComments, commentsWordingType };      
        const options = new AnnouncementTableOptions();
        options.announcementDateFormat = this.getDateFormat(elem);
        options.hidePriceSensitive = elem.getAttribute('data-invest-hide-price-sensitive')==='true';        
        if (elem.getAttribute('data-investi-num-announcements')){
          options.numAnnouncements = parseInt(elem.getAttribute('data-investi-num-announcements'));
        }
          
        announcements = this.filterAnnouncements(elem, announcements);
        
        this.setAnnouncementInteractiveTableData(elem, announcements, options);
      });
    });
  }

  getCommentsWordingType(elem:AnnouncementsInteractiveWidgetElement){
    let commentsWordingType:CommentsWordingType = 'comment';
    const wordingAttrVal:string = elem.getAttribute('data-investi-comments-wording');
    if(wordingAttrVal === 'question'){
      commentsWordingType = wordingAttrVal;
    }
    return commentsWordingType;
  }

  getAnnouncementInteractiveNav(data:AnnouncementsInteractiveWidgetData) : HTMLElement{

    const elem: HTMLElement = document.createElement('div');
    elem.className = 'investi-interactive-announcements-scroll-to-nav';


    if (window.matchMedia("(min-width: 1540px)").matches) {
      return elem;
    }

 

    const type = data.commentsWordingType;
    
    

    if (!window.matchMedia("(min-width: 800px)").matches) {
      const scrollToPdf: HTMLElement = document.createElement('span');
      scrollToPdf.innerHTML = '<a href="#investi-pdf-container">View PDF</a>';
      scrollToPdf.className = 'investi-interactive-announcements-scroll-to-pdf';    
      elem.appendChild(scrollToPdf);
    }
    

    if(!data.noComments){
      const scrollToAsk: HTMLElement = document.createElement('span');
      const wording = type === 'question' ? 'Ask a Question' : 'Add a comment';
      scrollToAsk.innerHTML = `<a href="#investi-add-comment-container">${wording}</a>`;
      scrollToAsk.className = 'investi-interactive-announcements-scroll-to-add-comment';    
      elem.appendChild(scrollToAsk);
    }
    if(elem.childNodes.length){
      const label: HTMLElement = document.createElement('span');
      label.innerText = "Scroll to:";
      label.className = 'investi-interactive-announcements-scroll-to-nav-label';
      elem.prepend(label);
    }
    
    

    return elem;
  }

  setAnnouncementInteractiveTableData(elem: AnnouncementsInteractiveWidgetElement, announcements:Announcement[], options: AnnouncementTableOptions) {
    
    const container: HTMLElement = document.createElement('div');
    container.className = 'investi-interactive-announcements-table-container'
    elem.appendChild(container);
    
    
    container.appendChild(this.getAnnouncementInteractiveNav(elem.investi));
    

    const header: HTMLElement = document.createElement('div');
    header.className = 'investi-interactive-announcements-header'
    const headerTitle: HTMLElement = document.createElement('div');
    headerTitle.innerText = elem.getAttribute('data-investi-announcement-header-title') || 'ASX Announcements';
    header.appendChild(headerTitle)
    container.appendChild(header);
    
    const tableElem: HTMLElement = document.createElement('table');
    const tableBody: HTMLElement = document.createElement('tbody');
    tableElem.appendChild(tableBody);
    
    container.appendChild(tableElem);
    const numAnnouncements = options.numAnnouncements || announcements.length;
    const show = Math.min(numAnnouncements, announcements.length);
    const rows:HTMLElement[] = [];        
    
    for (let i = 0; i < show; i++) {
      const announcement = announcements[i];
      const trElem: HTMLElement = document.createElement('tr');
      const tdDate: HTMLElement = document.createElement('td');
      tdDate.className = 'investi-interactive-announcements__date';      
      
      tdDate.innerHTML = this.getAnnouncementDate(options.announcementDateFormat, announcement)
      let tdHeadline: HTMLElement = document.createElement('td')
      tdHeadline.className = this.InteractiveAnnouncementsHeadlineClassName;
      let spanHeadline: HTMLElement = document.createElement('span')
      spanHeadline.innerText = announcement.headline;
      

      tdHeadline.onclick = () => { this.onAnnouncementSelected(elem, trElem, announcement)
        trElem.classList.add('investi-interactive-announcements-row-selected');
      };
      tdHeadline.append(spanHeadline);

      let tdComments: HTMLElement = document.createElement('td');
      if(announcement.numComments){
        
        let commentsSpan: HTMLElement = document.createElement('span')
        commentsSpan.className = 'investi-icon investi-icon-comment investi-interactive-announcements__comments';
        commentsSpan.innerText = `${announcement.numComments}` ;
        tdComments.append(commentsSpan);
      }
      

      trElem.appendChild(tdDate);
      trElem.appendChild(tdHeadline);
      trElem.appendChild(tdComments);
      trElem.className = `investi-interactive-announcements-row ${this.InteractiveAnnouncementsRowHiddenClassName}`;

      tableBody.appendChild(trElem);
      
      rows.push(trElem)
    }

    const onkeyup = (e:KeyboardEvent) => {
      const parent = this.getWidget<AnnouncementsInteractiveWidgetElement>(e.target);
      parent.investi.page = 0; //reset page to start to stop users going to an invalid page
      this.setAnnouncementInteractiveTableRowsVisible(elem)
    };
    
    header.append(this.getPaginationElement())

    if(elem.hasAttribute('data-investi-searchbox')){
      header.append(this.createSearchBox(rows, { onkeyup }));
    }

    this.setAnnouncementInteractiveTableRowsVisible(elem);

    elem.append(this.getPdfViewer(elem.investi));
      this.addPdfJsScript(elem,() => {
        this.pdfViewer = new PdfViewer(elem);
        if(rows.length){
          rows[0].querySelector<HTMLElement>(`.${this.InteractiveAnnouncementsHeadlineClassName}`).click();
        }
      });

    
    if(!elem.investi.noComments){
      const commentsContainer: HTMLElement = document.createElement('div');
      commentsContainer.className = 'investi-comments-container';
      elem.append(commentsContainer);
  
      elem.append(this.getAddCommentsElem(elem.investi.commentsWordingType))
    }
    
    
    
  }

  async onAnnouncementSelected(elem:AnnouncementsInteractiveWidgetElement, trElem:HTMLElement, announcement:Announcement){
    this.pdfViewer.setPdf(announcement, this.getAnnouncementHref(announcement));
    elem.investi.selectedElem?.classList.remove('investi-interactive-announcements-row-selected')
    elem.investi.selectedElem = trElem; 
    elem.investi.selected = announcement;       
    // trElem.classList.add('investi-interactive-announcements-row-selected');
    if(!elem.investi.noComments){
      elem.querySelector<HTMLElement>(".investi-add-comment-container").style.display = 'block';
      await this.loadComments(elem, announcement);
    }
    
    if(this.isMobile()){      
      const pdfContainer = elem.querySelector<HTMLElement>(".investi-pdf-container");
      pdfContainer.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  isMobile():boolean {
    return window.innerWidth < 800
  }
  

  getCommentVideoDiv(announcement:Announcement) : HTMLElement{
    const elem: HTMLElement = document.createElement('div');
    elem.className = 'investi-comments-video-container';
    elem.innerHTML = `<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="${announcement.videoUrl}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="${announcement.videoDescription}"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>`;
    
    const description: HTMLElement = document.createElement('div');   
    description.className = 'investi-comments-video-description'; 
    description.innerText = announcement.videoDescription || '';

    elem.appendChild(description);
    
    return elem;
  }

  async loadComments(elem: AnnouncementsInteractiveWidgetElement, announcement:Announcement){
    const container = elem.querySelector<HTMLElement>(".investi-comments-container");
    container.innerHTML = '';
    
    const noContent = !announcement.numComments && !announcement.videoUrl//no comments or video - hide div
    container.style.display = noContent ? 'none' : 'block'; 

    const commentsWordingType:CommentsWordingType = this.getCommentsWordingType(elem);
    const hasAnnouncementAttrName = 'investi-interactive-announcements-announcement-has-comment';
    elem.classList.remove(hasAnnouncementAttrName);

    if(noContent){
      return;
    }
    
    const headerContainer: HTMLElement = document.createElement('div');
    headerContainer.className = 'investi-comments-container-header';
    container.append(headerContainer);

    if(announcement.videoUrl){
      headerContainer.append(this.getCommentVideoDiv(announcement));
    }
    
    if(announcement.numComments){
      elem.classList.add(hasAnnouncementAttrName)
      let result:AnnouncementCommentsResult
      try {
        result = await this.httpCall<AnnouncementCommentsResult>('GET', `${this.baseAddress}/api/announcementComment?apiKey=${elem.investi.apiKey}&announcementGuid=${announcement.sendGuid}`, )
      } catch (error) {
        result = { errorMessage:error, comments:[] }      
      }
      if(result.errorMessage){
        console.error(result.errorMessage);
      }else{
        
        const commentCountElemContainer: HTMLElement = document.createElement('div');
        commentCountElemContainer.className = 'investi-comments-count-container'

        const commentCountElem: HTMLElement = document.createElement('h2');
        commentCountElem.className = 'investi-comments-count'        
        commentCountElem.innerText = `${result.comments.length} ${capitalizeFirstLetter(commentsWordingType)}${result.comments.length===1?'':'s'}`
        commentCountElemContainer.appendChild(commentCountElem);

        //const postCommentButton = document.createElement('button') as HTMLButtonElement;
        // postCommentButton.className = 'investi-comments-add-comment-button';        
         const postCommentLink = document.createElement('a') as HTMLAnchorElement;
        postCommentLink.className = 'investi-comments-add-comment-button investi-comments-add-comment-link'
        postCommentLink.href = '#investi-add-comment-container';
        // postCommentLink.appendChild(postCommentButton);
        postCommentLink.innerText = commentsWordingType === 'question' ? 'Ask Question' : 'Add Comment';
        
        commentCountElemContainer.appendChild(postCommentLink);
        
        headerContainer.append(commentCountElemContainer);
        
        for(let comment of result.comments){
          const commentRow: HTMLElement = document.createElement('div');
          commentRow.className = 'investi-comments-row'
          
          const commentElem: HTMLElement = document.createElement('blockquote');
          
          commentElem.className = 'investi-comments-comment';

          const commentSpan: HTMLElement = document.createElement('span');
          commentSpan.className = 'investi-comments-comment-text';
          commentSpan.innerText = comment.comment;
          commentElem.append(commentSpan);
          
          commentElem.prepend(this.getNameElem(comment, 'investi-comments-name-avatar'));
          // commentRow.appendChild(this.getNameAndDateElem(comment, ""))
          commentRow.appendChild(commentElem);
          for(let response of comment.responses){
            commentRow.appendChild(this.getCommentResponseElem(response));
          }
          container.append(commentRow);
        }
      }
      
    }
    
    
  }

  getCommentResponseElem(comment:AnnouncementCommentApi) : HTMLDivElement{
    const elem: HTMLDivElement = document.createElement('div');
    elem.className = 'investi-comments-response-container'
    
    const commentElem: HTMLElement = document.createElement('blockquote');
    
    

    commentElem.className = 'investi-comments-comment'
    commentElem.innerText = comment.comment;
    
    commentElem.prepend(this.getNameElem(comment, 'investi-comments-name-response-avatar'))
    elem.appendChild(commentElem);
    return elem;
  }

  getNameElem(comment:AnnouncementCommentApi, avatarClassName:string) : HTMLElement {
    
    

    const avatarElem: HTMLElement = document.createElement('div');
    avatarElem.className = avatarClassName;
    
    const nameElem: HTMLElement = document.createElement('div');
    nameElem.className = 'investi-comments-name'
    nameElem.innerText = `${comment.name}`;
    
    const elem: HTMLElement = document.createElement('div');
    elem.className = 'investi-comments-avatar-and-name';
    elem.appendChild(avatarElem);
    elem.appendChild(nameElem);

    const nameElemContainer: HTMLElement = document.createElement('div');
    nameElemContainer.className = 'investi-comments-name-container';
    nameElemContainer.appendChild(elem);
    nameElemContainer.appendChild(this.getDateElem(new Date(comment.date)));
    
    return nameElemContainer;
  }

  getDateElem(date:Date) : HTMLElement{
    const dateElem: HTMLElement = document.createElement('div');
    dateElem.className = 'investi-comments-date'
    const format1 = new simpleDateFormat('dd MMM yyyy', null);
    const format2 = new simpleDateFormat('h:mm a', null);
    dateElem.innerHTML = format1.format(date) + ' at ' + format2.format(date);
    return dateElem;
  }

  getAddCommentsElem(type:CommentsWordingType) : HTMLElement{
    const elem: HTMLElement = document.createElement('div');
    elem.className = 'investi-add-comment-container';
    elem.id = 'investi-add-comment-container'; //a href to this
    elem.style.display = 'none';

    const header: HTMLElement = document.createElement('h2');
    header.className = 'investi-add-comment-header';
    header.innerText = (type=='question'? 'Ask a Question':'Add a Comment') + ' about this announcement';
    elem.appendChild(header);

    const info: HTMLElement = document.createElement('div');    
    info.className = 'investi-add-comment-info';
    info.innerText = `All ${type}s are held for moderation. Approved ${type}s will be displayed publicly on this page with the announcement. Your email address will not be published.`;
    elem.appendChild(info);
    const wording = capitalizeFirstLetter(type);
    elem.appendChild(this.getFieldElem(wording, 'textarea', 'investi-add-comment-field-comment-textarea'));
    elem.appendChild(this.getFieldElem('Name', 'text','investi-add-comment-field-name-input'));
    elem.appendChild(this.getFieldElem('Email', 'email','investi-add-comment-field-email-input'));
    
    elem.appendChild(this.getPrivateCommentCheckbox(type)); 

    const button: HTMLButtonElement = document.createElement('button');    
    button.onclick = this.postComment.bind(this);
    button.innerText = `Post ${wording}`;
    button.className = 'investi-comments-add-comment-button';    
    elem.appendChild(button)

    const submittingElem = this.getLoadingElem()
    submittingElem.classList.add('investi-add-comment-submitting');    
    elem.appendChild(submittingElem);
    

    const successElem: HTMLDivElement = document.createElement('div');
    successElem.className = 'investi-add-comment-success';
    successElem.innerText = `Your ${wording} has been posted successfully! Please check your email to confirm it before it is sent to the moderators.`
    elem.appendChild(successElem)

    const errorElem: HTMLDivElement = document.createElement('div');
    errorElem.className = 'investi-add-comment-error';
    elem.appendChild(errorElem)

    return elem;
  }

  async postComment(e:MouseEvent) {
    const button = e.target as HTMLButtonElement;
    button.disabled = true;    
    const widget = this.getWidget<AnnouncementsInteractiveWidgetElement>(button);
    const parent = this.getParent(e.target, 'investi-add-comment-container');
    const commentElem = parent.querySelector('.investi-add-comment-field-comment-textarea') as HTMLInputElement
    const nameElem = parent.querySelector('.investi-add-comment-field-name-input') as HTMLInputElement
    const emailElem = parent.querySelector('.investi-add-comment-field-email-input') as HTMLInputElement
    const isPrivateCommentElem = parent.querySelector('.investi-add-comment-field-is-private-comment-checkbox') as HTMLInputElement
    const successElem = parent.querySelector('.investi-add-comment-success') as HTMLDivElement
    const errorElem= parent.querySelector('.investi-add-comment-error') as HTMLDivElement
    const submittingElem = parent.querySelector('.investi-add-comment-submitting') as HTMLDivElement

    successElem.style.display = 'none';
    errorElem.style.display = 'none';
    submittingElem.style.display = 'initial';

    const data:AnnouncementCommentRequest= {
      announcementGuid : widget.investi.selected.sendGuid,
      apiKey: widget.investi.apiKey,
      name: nameElem.value,
      isPrivate : isPrivateCommentElem.checked,
      email: emailElem.value,
      comment: commentElem.value,
      locationHref: window.location.href
    };

    let result:AnnouncementCommentResult;
    try {
      result = await this.httpCall<AnnouncementCommentResult>('POST', `${this.baseAddress}/api/announcementComment`, data)
    } catch (error) {
      result = { errorMessage:error }      
    }
    submittingElem.style.display = 'none';
    if(result.errorMessage){
      button.disabled = false;      
      errorElem.style.display = 'block';
      errorElem.innerText = result.errorMessage;
    }else{
      successElem.style.display = 'block';
    }
    
    
  }

  getParent(child:EventTarget, className:string):HTMLElement{
    let count = 0;
    let parent = (child as HTMLElement).parentElement;
    while(count<20){
      const pageAttr = parent.classList.contains(className)
      if(pageAttr){          
        return parent;        
      }else{
        parent = parent.parentElement;
        count++;
      }
    }
  }

  httpCall<T>(method: string, url: string, data?: any) : Promise<T> {
    
    return new Promise<T>((resolve, reject)=>{
      const xhr = new XMLHttpRequest();
      xhr.open(method, url, true);
      xhr.onload = e=> 
      {        
        if(xhr.status === 200){
          resolve(JSON.parse(xhr.responseText) as T);
        }else{
          reject(`${xhr.status} ${xhr.statusText}`)
        }
         
      };
      if (data) {
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(JSON.stringify(data));
      }
      else xhr.send();
    })
    
  }

  httpError(err:string) : string {
    console.error(err);
    return err;
  }

  getPrivateCommentCheckbox(type:CommentsWordingType){
    const field:HTMLElement = document.createElement('p');
    field.className = 'investi-comments-field';
    const label:HTMLElement = document.createElement('label');
    const checkbox:HTMLInputElement = document.createElement('input');    
    checkbox.type = 'checkbox';     
    checkbox.className = 'investi-add-comment-field-is-private-comment-checkbox';   
    label.innerText = `Do not post my ${type} publicly`;   
    label.className = 'investi-add-comment-field-is-private-comment-label';
    label.prepend(checkbox);
    field.appendChild(label);
    return field;
  }

  getFieldElem(labelText:string,inputType:InputType, className:string) : HTMLElement{
    const field:HTMLElement = document.createElement('p')
    field.className = 'investi-comments-field';
    const label:HTMLElement = document.createElement('label')
    label.className = 'investi-comments-field-label';
    label.innerText = labelText;
    field.appendChild(label);
    if(inputType === 'textarea'){
      const textarea:HTMLTextAreaElement = document.createElement('textarea');
      textarea.cols  = 45;
      textarea.rows = 8;
      textarea.maxLength = 2000;
      textarea.className = className;
      field.appendChild(textarea);
    }else if(inputType === 'text' || inputType === 'email'){
      const inputElem:HTMLInputElement = document.createElement('input');
      inputElem.type = inputType;
      inputElem.className = className;
      field.appendChild(inputElem);
    }
    
    return field;
  }

  addPdfJsScript(elem:HTMLElement, onload:()=>void){
    // const scripts = Array.from(document.getElementsByTagName('script')).map(x=>x.src);
    const script = document.createElement('script');
      script.type = 'module';
      script.src = this.PdfJsScriptSrc;
      script.onload = onload;
      document.body.appendChild(script);
    
  }

  getPdfAnchorElement(){
    const elem = document.createElement('div');  
    elem.className = 'investi-pdf-error-loading';
    const span = document.createElement('span');
    span.innerText = "Error loading PDF"
    
    elem.append(span);
    
    return elem;
  }

  getLoadingElem(){
    const loading:HTMLElement = document.createElement('div');
    loading.style.display = 'none';
    loading.className = 'investi-loading'
    loading.innerHTML = '<div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>'
    return loading;
  }

  getPdfViewer(data:AnnouncementsInteractiveWidgetData):HTMLElement{
    const commentsWordingType = data.commentsWordingType;
    const elem: HTMLElement = document.createElement('div');
    elem.className = 'investi-pdf-container';
    elem.id = 'investi-pdf-container'; //mobile nav
    const info:HTMLElement = document.createElement('div');    
    info.className = 'investi-pdf-info'  
    const infoAnnouncementHeadline:HTMLElement = document.createElement('div');
    infoAnnouncementHeadline.className = 'investi-pdf-info-announcement-headline';     
    info.appendChild(infoAnnouncementHeadline);

    elem.append(info);


    elem.append(this.getLoadingElem());
    elem.append(this.getPdfAnchorElement());

    const pdfCanvasHeader = document.createElement('div');
    pdfCanvasHeader.className = 'investi-pdf-canvas-header';    
    elem.append(pdfCanvasHeader);

    const buttonsElem = document.createElement('div');
    buttonsElem.className = 'investi-pdf-buttons';
    pdfCanvasHeader.append(buttonsElem);    

    const span = document.createElement('span');
    span.innerText = 'PDF Page: '
    const pageNumSpan = document.createElement('span');
    pageNumSpan.className = 'investi-pdf-page-num';
    span.appendChild(pageNumSpan);

    const pageDivider = document.createElement('span');
    pageDivider.innerText = ' / ';
    span.appendChild(pageDivider);

    const pageCountSpan = document.createElement('span');
    pageCountSpan.className = 'investi-pdf-page-count';
    span.appendChild(pageCountSpan);
    buttonsElem.append(span);

    const buttonPrev = document.createElement('button');
    buttonPrev.className = 'investi-pdf-prev-page-btn';
    buttonPrev.innerText = '<<';    
    buttonsElem.append(buttonPrev);

    const buttonNext = document.createElement('button');
    buttonNext.className = 'investi-pdf-next-page-btn';
    buttonNext.innerText = '>>';    
    buttonsElem.append(buttonNext);

    const pdfLinks = <HTMLDivElement>document.createElement('div');
    pdfLinks.className = 'investi-pdf-links';

    const downloadPdfElem: HTMLAnchorElement = <HTMLAnchorElement>document.createElement('a');
    downloadPdfElem.className = 'investi-pdf-announcement-link'    
    downloadPdfElem.target = "_blank";
    downloadPdfElem.innerText = "Download PDF";    
    pdfLinks.append(downloadPdfElem);

    if(!data.noComments){
      const addCommentLink: HTMLAnchorElement = <HTMLAnchorElement>document.createElement('a');
      addCommentLink.className = 'investi-add-a-comment-link'    
      addCommentLink.href = "#investi-add-comment-container";    
      addCommentLink.innerText = commentsWordingType === 'question' ? 'Ask a Question' : 'Add a comment';
      pdfLinks.append(addCommentLink)
    }
    
    
    pdfCanvasHeader.append(pdfLinks);
    
    const canvas = document.createElement('canvas');
    canvas.className = 'investi-pdf-canvas';
    // const container = document.createElement('div');
    // container.className = 'investi-pdf-canvas-container';
    // container.append(canvas);
    elem.append(canvas);


    return elem;
  }
  
  getPaginationElement():HTMLElement{
    const elem: HTMLElement = document.createElement('div');
    elem.className = 'investi-announcements-pagination-container';

    const infoElem: HTMLElement = document.createElement('div');
    infoElem.className = 'investi-announcements-pagination-showing-text'
    elem.appendChild(infoElem);

    const controlsElem: HTMLElement = document.createElement('div');
    controlsElem.className = 'investi-announcements-pagination-controls';
    const prevElem: HTMLButtonElement = this.getPaginationButton(true, 'Prev')
    controlsElem.appendChild(prevElem);
    const nextElem: HTMLButtonElement = this.getPaginationButton(false, 'Next')
    controlsElem.appendChild(nextElem);
    elem.appendChild(controlsElem);

    return elem;
  }

  getPaginationButton(isPrev:boolean, buttonText:string) : HTMLButtonElement{
    const button: HTMLButtonElement = document.createElement('button');
    button.className = `investi-announcements-pagination-controls-${isPrev?'prev':'next'}`;
    button.innerText = buttonText;
    button.onclick = (e:MouseEvent)=>{
          
      const parent = this.getWidget<AnnouncementsInteractiveWidgetElement>(e.target);
      const page = parent.investi.page;
      
      if(page !== undefined){
        parent.investi.page = page + (isPrev ? -1 : 1);        
        this.setAnnouncementInteractiveTableRowsVisible(parent);
      }
      
    }
    return button;
  }



  getWidget<T>(target:EventTarget):T{
    let parent = (target as HTMLElement);
    let count = 0;
    while(count<20){
      const widget = parent as IWidgetElement<T>;
      if(widget.investi){          
        return widget as T;        
      }else{
        parent = parent.parentElement;
        count++;
      }
    }
    console.warn(`unable to find investi widget from child ${target}`)
  }

  setAnnouncementInteractiveTableRowsVisible(elem:AnnouncementsInteractiveWidgetElement){
    
    const page = elem.investi.page;
    const numPerPage = +elem.getAttribute('data-investi-announcements-per-page') || this.InteractiveAnnouncementsPerPageDefault;
    let rows:HTMLElement[] = Array.from(elem.querySelectorAll<HTMLElement>(".investi-interactive-announcements-row"));
    rows = this.filterRowsMatchingSearchbox(elem, rows);
    
    const lower = page*numPerPage;
    const upper = Math.min(lower + numPerPage, rows.length);   
    let visibleCount = 0; 
    for (let i = 0; i < rows.length; i++) {
      const tr = rows[i];
      
      if(i >= lower && i < upper){
        tr.classList.remove(this.InteractiveAnnouncementsRowHiddenClassName)
        visibleCount++;

        if(visibleCount % 2 !== 0){
          tr.classList.add('investi-interactive-announcements-row-odd')
          tr.classList.remove('investi-interactive-announcements-row-even')
        }else{
          tr.classList.add('investi-interactive-announcements-row-even')
          tr.classList.remove('investi-interactive-announcements-row-odd')
        }
      }else{
        tr.classList.add(this.InteractiveAnnouncementsRowHiddenClassName)
      }
    }
    let text = rows.length===0 ? 'No results' : `Showing ${lower+1}-${upper} of ${rows.length}`
    elem.querySelector<HTMLElement>('.investi-announcements-pagination-showing-text').innerText = text;
    elem.querySelector<HTMLButtonElement>('.investi-announcements-pagination-controls-prev').disabled = page === 0;
    elem.querySelector<HTMLButtonElement>('.investi-announcements-pagination-controls-next').disabled = upper === rows.length;
    
  }

  filterRowsMatchingSearchbox(elem:HTMLElement, rows:HTMLElement[]){
    const val = (elem.querySelector('.investi-searchbox') as HTMLInputElement)?.value;
    const filterText = (val || "").toLowerCase();
    const getTextFunc = (row:HTMLElement):string => row.querySelector<HTMLElement>(`.${this.InteractiveAnnouncementsHeadlineClassName}`).innerText;
    let filteredRows = [];
    for(let row of rows){
      if(filterText === ""){
        row.style.display = "";
        filteredRows.push(row)   

      }else{
        const matches = getTextFunc(row).toLowerCase().indexOf(filterText)> -1;
        row.style.display =  matches ? "" : "none";       
        if(matches){
          filteredRows.push(row)
        }
        
      }
      
    }
    return filteredRows; 
  }
  
  setAnnouncementData(elem: HTMLElement, announcements:Announcement[], options: AnnouncementTableOptions) {
    var tableElem: HTMLElement = document.createElement('table');
    //tableElem.className = 'table table-striped table-bordered table-hover';
    var tableHeader: string = '<thead> <tr> <th>Date</th> <th>Headline</th> ';
    if (!options.hidePriceSensitive)
      tableHeader += '<th>Price Sensitive</th>';
    tableHeader +=' </tr> </thead> ';
    tableElem.innerHTML = tableHeader;
    var tableBody: HTMLElement = document.createElement('tbody');
    tableElem.appendChild(tableBody);
    
    elem.appendChild(tableElem);
    const numAnnouncements = options.numAnnouncements || announcements.length;
    const show = Math.min(numAnnouncements, announcements.length);
    const rows:HTMLElement[] = [];
    for (var i = 0; i < show; i++) {
      var announcement = announcements[i];
      var trElem: HTMLElement = document.createElement('tr');
      var tdDate: HTMLElement = document.createElement('td');
      var mySimpleDateFormatter = new simpleDateFormat(options.announcementDateFormat || 'dd MMM yy h:mm a', null);
      
      //tdDate.innerHTML = this.formatDate(new Date(announcement.date));
      tdDate.innerHTML = mySimpleDateFormatter.format(new Date(announcement.date));

      let tdHeadline: HTMLElement = this.getAnnTdElement(announcement);
      tdHeadline.className = "investi-announcements-table-headline";
      var tdPriceSensitive: HTMLElement = document.createElement('td');
      tdPriceSensitive.innerHTML = announcement.priceSensitive ? "&#10004;" : "";

      trElem.appendChild(tdDate);
      trElem.appendChild(tdHeadline);
      if (!options.hidePriceSensitive)
        trElem.appendChild(tdPriceSensitive);    

      tableBody.appendChild(trElem);
      rows.push(trElem)
    }

    const getTextFunc = (row:HTMLElement):string => row.querySelector<HTMLElement>(".investi-announcements-table-headline").innerText;
    
    if(elem.hasAttribute('data-investi-searchbox')){
      elem.prepend(this.createSearchBox(rows, { getTextFunc }));
    }
  }

  getAnnTdElement(announcement:Announcement): HTMLElement {
    var tdLink: HTMLElement = document.createElement('td');
    
    tdLink.appendChild(this.getAnnLink(announcement));
    return tdLink;
  }



  createInvestiAnnouncementSummary() {
    
    this.doActionOnIdOrClass(AnnouncementsSummaryWidgetName, (elem, apiKey) => {
      
      this.getAnnouncementData(apiKey, announcements => {
        this.createInvestiAnnouncementSummaryInternal(elem, announcements, false)
      });
    });
  }



  createInvestiAnnouncementSummaryInternal(elem: HTMLElement, container:IApiKeyWrapper, v2:boolean) {     
    
    let announcements = container.announcements;
    if(this.checkSubscriptionExpired(elem, container))
      return;

    let numAnnouncements = 3;
    
    let dateFormat = elem.getAttribute('data-investi-date-format');
    if (elem.hasAttribute('data-investi-num-announcements'))
      numAnnouncements = parseInt(elem.getAttribute('data-investi-num-announcements'));
    
    announcements = this.filterAnnouncements(elem, announcements);
    
    this.setNoDataMessage(elem, announcements);
    
    if(isNaN(numAnnouncements)){
      numAnnouncements = announcements.length;
    }
    Math.min(numAnnouncements, announcements.length)
    const rows:HTMLElement[] = [];
    for (let i = 0; i < Math.min(numAnnouncements, announcements.length); i++) {
      
      const announcement = announcements[i];
      const date = this.getAnnouncementDate(dateFormat, announcement)
      
      if(v2){
        const row = this.createAnnouncementSummaryContent_v2(elem, announcement, date)
        rows.push(row)
      } else{
        this.createAnnouncementSummaryContent_v1(elem, announcement, date);
      }
      
    }
    
    const getTextFunc = (row:HTMLElement):string => row.querySelector<HTMLElement>(`.investi-announcement-headline`).innerText;
    
    if(v2 && elem.hasAttribute('data-investi-searchbox')){
      elem.prepend(this.createSearchBox(rows, {getTextFunc}));
    }
  }

  getAnnouncementDate(dateFormat:string, announcement:Announcement):string {
    const mySimpleDateFormatter = new simpleDateFormat(dateFormat || 'dd MMM yyyy', null);  
    const date = mySimpleDateFormatter.format(new Date(announcement.date));
    return date;
  }

  createAnnouncementSummaryContent_v1(elem: HTMLElement, announcement, date) {
    var div: HTMLElement = document.createElement('div');        
    
    div.innerHTML = date;
    var h4: HTMLElement = document.createElement('h4');    
    let aHref = this.getAnnLink(announcement);
    h4.appendChild(aHref);

    elem.appendChild(div);
    elem.appendChild(h4);    
  }

  createAnnouncementSummaryContent_v2(elem, announcement, date) : HTMLDivElement{
    var rowElem: HTMLDivElement = document.createElement('div');        
    rowElem.className = 'investi-announcement-row';
    
      
    // rowElem.addEventListener('click', ()=> {
    //   window.open(this.getAnnouncementHref(announcement), '_blank');      
    // });
    
    const dateElem: HTMLElement = document.createElement('div');
    dateElem.className = 'investi-announcement-date'; 
    dateElem.innerHTML = date;
    rowElem.appendChild (dateElem);  
    
    const headlineElem: HTMLElement = document.createElement('div');
    headlineElem.className = 'investi-announcement-headline'; 
    
    //const aHref: HTMLAnchorElement = <HTMLAnchorElement>document.createElement('a');
    // headlineElem.innerText = announcement.headline;
    //aHref.innerText = announcement.headline;
    //aHref.href = "javascript:void(0);"

    const aHref = this.getAnnLink(announcement);
    headlineElem.appendChild(aHref);
    rowElem.appendChild (headlineElem);  

    elem.appendChild(rowElem);
    return rowElem;
    
  }

  createInvestiAnnouncementSummary_v2() {
   
    this.doActionOnIdOrClass(AnnouncementsSummaryv2WidgetName, (elem, apiKey) => {
      
      this.getAnnouncementData(apiKey, announcements => {                
        this.createInvestiAnnouncementSummaryInternal(elem, announcements, true)
      });
    });
  }

  createInvestiAnnouncementTab() {
    
    this.doActionOnIdOrClass(AnnouncementsTabWidgetName, (elem, apiKey) => {
      
      this.getAnnouncementData(apiKey, announcements => {
        this.createInvestiAnnouncementTabInternal(elem, announcements)
      });
    });   
  }

  createSearchBox(rows:HTMLElement[], options:SearchBoxOptions) :HTMLDivElement  {     
    const searchBoxContainer: HTMLDivElement = <HTMLDivElement>document.createElement('div');
    searchBoxContainer.className = 'investi-searchbox-container';
    const input: HTMLInputElement = <HTMLInputElement>document.createElement('input');
    input.setAttribute('placeholder', 'Search...');
    input.className = 'investi-searchbox';    
    searchBoxContainer.append(input);

    const countElem: HTMLElement = <HTMLElement>document.createElement('div');
    countElem.className = 'investi-searchbox__results-count';
    searchBoxContainer.append(countElem);

    if(options.getTextFunc){
      input.onkeyup = e => {
        const count = this.setRowsVisible(input.value, rows, options.getTextFunc)      
        countElem.innerText = count===undefined?'': `${count} match${count==1?'':'es'}`;
      };
    }else if(options.onkeyup){
      input.onkeyup = options.onkeyup;
    }
    

    return searchBoxContainer;
  }

  setRowsVisible(filterText:string, rows:HTMLElement[], getText:(row:HTMLElement)=>string) : number | undefined {
    
    filterText = (filterText || "").toLowerCase();

    if(filterText === ""){
      for(let row of rows){
        row.style.display = "";   
      }
      return undefined;      
    }
    
    let count = 0;
    for(let row of rows){
      const matches = getText(row).toLowerCase().indexOf(filterText)> -1;
      count += (matches ? 1 : 0);
      row.style.display =  matches ? "" : "none";       
    }
    return count;
  }

  createInvestiAnnouncementTabInternal(elem: HTMLElement, container:IApiKeyWrapper) {     
        
    let announcements = container.announcements;
    if(this.checkSubscriptionExpired(elem, container))
      return;
    const dateFormat = elem.getAttribute('data-investi-date-format');
    const showSelect = elem.getAttribute('data-investi-include-select-for-additional-years')==='true';
    
    const rows:HTMLDivElement[] = [];
    announcements = this.filterAnnouncements(elem, announcements);    
    this.setNoDataMessage(elem, announcements);
    
    const investiTab: HTMLDivElement = <HTMLDivElement>document.createElement('div');    
    investiTab.classList.add("investi-tab");    
    elem.appendChild(investiTab)
    
    let currentYear = -1;
    let yearCount = 0;
    let tabContentDiv;
    for (let i = 0; i < announcements.length; i++) {
      const announcement = announcements[i];
      const annDate = new Date(announcement.date);            
      if (annDate.getFullYear() != currentYear) {
        yearCount++;       
        currentYear = annDate.getFullYear();
        const buttonElem: HTMLButtonElement = <HTMLButtonElement>document.createElement('button');
        buttonElem.className = "investi-tablinks";
        buttonElem.innerText = currentYear + "";
        buttonElem.setAttribute('data-investi-year', currentYear+'');
        buttonElem.addEventListener("click", (e:any)=> { this.onTabClick(e)});
        investiTab.appendChild(buttonElem);

        tabContentDiv = this.getAnnouncementTabContentDiv(currentYear);
        elem.appendChild(tabContentDiv);
      }
      const date = this.getAnnouncementDate(dateFormat, announcement)
      const row = this.createAnnouncementSummaryContent_v2(tabContentDiv, announcement, date)    
      rows.push(row);
    }

    if(showSelect){
      const startYear = --currentYear;
      const options = this.getAnnouncementFilterOptions(elem);
      options.maxYears = undefined;
      options.startYear = undefined;
      const additionalYearsAnnouncements = this.filterAnnouncementsFromOptions(options, container.announcements);
      const annGroups = this.getAnnouncementsGrouped(additionalYearsAnnouncements);
      const annYears = Object.keys(annGroups).map(x=>+x).filter(x=>x <= startYear).sort((a, b) => b-a);
      const priorYearText = elem.getAttribute('data-investi-select-prior-year-text') || '-- Prior Year --';
      investiTab.appendChild(this.getAnnouncementTabSelect(startYear, annYears, priorYearText));
      this.appendAdditionalYearsContent(elem, annGroups, annYears, dateFormat, rows);
    }

    const firstButtonElement = elem.querySelector<HTMLButtonElement>('button');
    if(firstButtonElement){
      firstButtonElement.click();      
    } 

    const getTextFunc = (row:HTMLDivElement):string => row.querySelector<HTMLDivElement>(".investi-announcement-headline").innerText;
    
    if(elem.hasAttribute('data-investi-searchbox')){
      investiTab.append(this.createSearchBox(rows, {getTextFunc}));
    }
  }

  getAnnouncementTabContentDiv(year:number){
    const contentDiv = <HTMLDivElement>document.createElement('div');
    contentDiv.className = "investi-tabcontent";
    contentDiv.setAttribute('data-investi-year', year+'');
    return contentDiv;
  }

  getAnnouncementsGrouped(announcements:Announcement[]){
    const groupedByYear = announcements.reduce((acc, announcement) => {
      const year = new Date(announcement.date).getFullYear(); // Get the full year from the ISO string
      if (!acc[year]) {
        acc[year] = [];
      }
      acc[year].push(announcement);
      return acc;
    }, {} as { [year: number]: Announcement[] });
    return groupedByYear;
  }

  appendAdditionalYearsContent(elem:HTMLElement, groupedByYear:{ [year: number]: Announcement[] }, annYears:number[], dateFormat:string, rows:HTMLDivElement[]){

    for(let year of annYears){
      const tabContentDiv = this.getAnnouncementTabContentDiv(year)
      elem.appendChild(tabContentDiv);
      
      for(let announcement of groupedByYear[year]){
      const date = this.getAnnouncementDate(dateFormat, announcement)
      const row = this.createAnnouncementSummaryContent_v2(tabContentDiv, announcement, date)    
      rows.push(row);
      }
    }
  }
  
  getAnnouncementTabSelect(startYear:number, annYears:number[], priorYearText:string){    
    
    const selectContainer = <HTMLDivElement>document.createElement('div');
    selectContainer.className = 'investi-tablinks investi-tab-additional-year-select-container';
    selectContainer.setAttribute('data-investi-year', startYear+'');
    // const yearLabel = <HTMLLabelElement>document.createElement('label');
    // yearLabel.className = 'investi-tab-additional-year-label'
    // yearLabel.innerText = 'Addtional Years: ';
    //selectContainer.append(yearLabel);

    const selectElem = <HTMLSelectElement>document.createElement('select');
    selectElem.className = 'investi-tab-additional-year-select';        
    
    const optionYearElement = <HTMLOptionElement>document.createElement('option');
    selectElem.className = 'investi-tab-additional-year-option';
    
    optionYearElement.innerText = priorYearText;
    selectElem.appendChild(optionYearElement)
    
    for (let year of annYears) {
      const optionYearElement = <HTMLOptionElement>document.createElement('option');
      selectElem.className = 'investi-tab-additional-year-option';
      optionYearElement.innerText = `${year}`;
      selectElem.appendChild(optionYearElement)
    }

    
    selectContainer.append(selectElem);

    
    selectElem.addEventListener("change", (event:any) => {
      
      
      if(event.target.value != priorYearText){
        const widgetElem = this.getParent(selectElem, 'investi-announcements-tab');
        this.onTabClicked(selectContainer, event.target.value, widgetElem);        
      }
      
    });

    return selectContainer;

  }
  onTabClick(e:PointerEvent){
    const button = e.target as HTMLButtonElement;
    const year = button.getAttribute('data-investi-year');
    this.onTabClicked(button, year, button.parentElement.parentElement);
    
  }

  onTabClicked(tabLinkElem:HTMLElement, year:string, announcementsTabElem:HTMLElement){
    
    
    // Get all elements with class="tabcontent" and hide them
    const contents = announcementsTabElem.querySelectorAll<HTMLElement>(".investi-tabcontent");
    if(contents){
      for(let content of Array.from(contents)){
        if(!content.dataset.originalDisplay){
          const computedStyle = window.getComputedStyle(content).display;
          if(computedStyle && computedStyle !== 'none'){
            content.dataset.originalDisplay = computedStyle;

          }
        }
        content.style.display = 'none';
      }      
    }    
  
    // Get all elements with class="tablinks" and remove the class "active"
    const tablinks = announcementsTabElem.querySelectorAll<HTMLElement>(".investi-tablinks");
    if(tablinks){
      for (let i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
        
      }
  
    }
   // Show the current tab, and    
   const content = announcementsTabElem.querySelector<HTMLElement>(`.investi-tabcontent[data-investi-year='${year}']`)
    if(content){      
      
      content.style.display = content.dataset.originalDisplay || 'block';
      
      
    }else{
      console.error(`unable to find content div for year ${year}`)
    }
   //add an "active" class to the button/elem that opened the tab
   tabLinkElem.className += " active";
        
  }

  filterAnnouncements(elem: HTMLElement, announcements:Announcement[]) : Announcement[] {
    const options = this.getAnnouncementFilterOptions(elem);
    return this.filterAnnouncementsFromOptions(options, announcements);
  }

  getAnnouncementFilterOptions(elem: HTMLElement) : AnnouncementFilterOptions {
    const options:AnnouncementFilterOptions = {
      priceSensitiveOnly : elem.hasAttribute('data-investi-price-sensitive-only'),
      filterRegex : elem.getAttribute('data-investi-filter-regex'),
      maxYears : parseInt(elem.getAttribute('data-investi-maximum-num-years')),
      startYear : parseInt(elem.getAttribute('data-investi-start-year'))
    };    
    return options; 
  }

  

  filterAnnouncementsFromOptions(filterOptions: AnnouncementFilterOptions, announcements:Announcement[]) : Announcement[] {
    
    const { priceSensitiveOnly,filterRegex,maxYears,startYear } = filterOptions;
    
    if(!priceSensitiveOnly && !filterRegex && !maxYears && !startYear){
      return announcements;
    }
    const arr = [];
    let regExp: RegExp;
    if (filterRegex){
      regExp = new RegExp(filterRegex, "i");
    }
    
    const currentYear = new Date().getFullYear();

    for(let announcement of announcements){
      if (announcement.priceSensitive || !priceSensitiveOnly) {
        
        if (!filterRegex || announcement.headline.match(regExp)){
          
          const fullYear = new Date(announcement.date).getFullYear();

          if(!isNaN(startYear) && fullYear < startYear){
            continue;
          }

          if(!maxYears || (currentYear - fullYear) < maxYears){
            arr.push(announcement)
          }
        }
      }
    }


    
    return arr;    
  }

  getAnnLink(announcement:Announcement): HTMLAnchorElement {
    const aHref: HTMLAnchorElement = <HTMLAnchorElement>document.createElement('a');
    aHref.href =   this.getAnnouncementHref(announcement);    
    aHref.target = "_blank";
    aHref.innerText = announcement.headline;
    return aHref;
  }

  getAnnouncementHref(announcement:Announcement): string {
    let href:string = announcement.localPath;
    if(!announcement.localPath.startsWith('http')){
      href = this.baseAddress + href;  
    }
   return href;
  }

  createInvestiHeaderWidget() {
    var elems: HTMLCollectionOf<Element> = document.getElementsByClassName(HeaderPriceWidgetName);
    if (elems.length === 0)
      return;

    this.getMarketData('', (marketData) => {
      this.createPriceWidget(elems, marketData, true);
    });
  }

  createHeaderPrice() {
    var elems: HTMLCollectionOf<Element> = document.getElementsByClassName(HeaderPriceWidgetNamev2);
    if (elems.length === 0)
      return;

    this.getMarketData('', (marketData) => {
      this.createHeaderPriceInternal(elems, marketData);
    });
  }

  createinvestiPriceOnTopWidget() {
    var elems: HTMLCollectionOf<Element> = document.getElementsByClassName(PriceOnTopWidgetName);
    if (elems.length === 0)
      return;

    this.getMarketData('', (marketData) => {
      this.createPriceWidget(elems, marketData, false);
    });
  }

  createHeaderPriceInternal(elems: HTMLCollectionOf<Element>, container:IApiKeyWrapper) {
    const marketData = container.marketData;
    for (let i = 0; elems[i]; i++) {
      let elem = elems[i] as HTMLElement;
      if(this.checkSubscriptionExpired(elem, container))
        continue;
      const stockTicker: HTMLElement = document.createElement('div');
      stockTicker.className = 'investi-header-price-widget-ticker';
      elem.appendChild(stockTicker);
      stockTicker.innerHTML = `${marketData.exchange}:${marketData.ticker}`;

      const updatedDiv: HTMLElement = document.createElement('div');
      updatedDiv.innerHTML = this.formatDate(new Date(marketData.updated));
      updatedDiv.className = 'investi-header-price-widget-updated';
      elem.appendChild(updatedDiv);
      
      const momementDiv: HTMLElement = document.createElement('div');
      momementDiv.className = 'investi-header-price-widget-momement';
      const movementPercentElem: HTMLElement = document.createElement('div');
      movementPercentElem.className = 'investi-header-price-widget-movementPercentElem';
      this.setMovementElem(marketData, momementDiv, movementPercentElem, elem);
      elem.appendChild(momementDiv);
      elem.appendChild(movementPercentElem);
      
      let priceDiv = this.getPriceWidgetLastPriceDiv(this.addZeroes(marketData.last, elem), marketData.currency);
      priceDiv.className = 'investi-header-price-widget-last';
      elem.appendChild(priceDiv);
    }

  }
 
  createPriceWidget(elems: HTMLCollectionOf<Element>, container:IApiKeyWrapper, appendPriceAtEnd:boolean) {
    
    const marketData:StockMarketData = container.marketData;
    for (let i = 0; elems[i]; i++) {

      let elem = elems[i] as HTMLElement;
      if(this.checkSubscriptionExpired(elem, container))
        continue;
      //var container: HTMLElement = document.createElement('div');
      var cell1: HTMLElement = document.createElement('div');
      var stockTicker: HTMLElement = document.createElement('div');
      stockTicker.className = 'investi-header-price-widget-ticker';
      cell1.appendChild(stockTicker);
      stockTicker.innerHTML = `${marketData.exchange}:${marketData.ticker}`;

      var updatedDiv: HTMLElement = document.createElement('div');
      updatedDiv.innerHTML = this.formatDate(new Date(marketData.updated));
      updatedDiv.className = 'investi-header-price-widget-updated';
      cell1.appendChild(updatedDiv);

      var momementContainer: HTMLElement = document.createElement('div');
      momementContainer.className = 'investi-header-price-widget-container';
      var momementDiv: HTMLElement = document.createElement('span');
      momementDiv.className = 'investi-header-price-widget-momement';
      var movementPercentElem: HTMLElement = document.createElement('span');
      movementPercentElem.className = 'investi-header-price-widget-movementPercentElem';
      this.setMovementElem(marketData, momementDiv, movementPercentElem, elem);
      momementContainer.appendChild(momementDiv);
      momementContainer.appendChild(movementPercentElem);
      cell1.appendChild(momementContainer);
      let priceDiv = this.getPriceWidgetLastPriceDiv(this.addZeroes(marketData.last, elem), marketData.currency);
      if (!appendPriceAtEnd)
        elem.appendChild(priceDiv);
      elem.appendChild(cell1);
      if(appendPriceAtEnd)
        elem.appendChild(priceDiv);
    }

  }
  getPriceWidgetLastPriceDiv(last:number, currency:string): HTMLElement{
    var cell2: HTMLElement = document.createElement('div');
    this.setPriceWidgetLastPriceDiv(cell2, last, currency);
    return cell2;

  }

  setPriceWidgetLastPriceDiv(cell2: HTMLElement, last:number, currency:string): HTMLElement{

    var spanDollarSign: HTMLElement = document.createElement('span');
    spanDollarSign.innerHTML = this.getDollarSign(currency);
    spanDollarSign.className = 'investi-header-price-widget-dollar-sign';
    cell2.appendChild(spanDollarSign);

    var priceElem: HTMLElement = document.createElement('span');
    priceElem.innerHTML = last+'';
    priceElem.className = 'investi-header-price-widget-last-price';
    cell2.appendChild(priceElem);
    return cell2;
  }

  createInvestiAnnouncementAccordion(){    
    this.doActionOnIdOrClass(AnnouncementsAccordionWidgetName, (elem, apiKey) => {      
      this.getAnnouncementData(apiKey, announcements => {
        this.createInvestiAnnouncementAccordionInternal(elem, announcements)
      });
    });
  }

  setNoDataMessage(elem: HTMLElement, announcements:Announcement[]){
    if(!announcements.length){
      let noDataMessage =  elem.getAttribute('data-investi-no-data-message');
      if(!noDataMessage){
        noDataMessage = 'No announcements';
        if(elem.hasAttribute('data-investi-filter-regex')){
          noDataMessage += ` match the filter: ${elem.getAttribute('data-investi-filter-regex')}`;
        }
      }
      elem.innerHTML = noDataMessage;     
    }
  }
  
  createInvestiAnnouncementAccordionInternal(elem: HTMLElement, container:IApiKeyWrapper) {
            
    let announcements = container.announcements;
    if(this.checkSubscriptionExpired(elem, container))
      return;

    let dateFormat = elem.getAttribute('data-investi-date-format');    
    let showPriceSensitiveColumn = elem.hasAttribute('data-investi-show-price-sensitive-column') || false;
    let collapsed = elem.hasAttribute('data-investi-accordion-collapsed') || false;
    
    
    const rows:HTMLElement[] = []    
    elem.innerHTML = '';
    var currentYear = -1;
    let tableCount = 0;
    let tableElem: HTMLElement;
    var that = this;    
    announcements = this.filterAnnouncements(elem, announcements);
    
    this.setNoDataMessage(elem, announcements);
 
    for (var i = 0; i < announcements.length; i++) {
      var announcement = announcements[i];
      var annDate = new Date(announcement.date);
      
      if (annDate.getFullYear() != currentYear) {
        tableCount++;
        
        currentYear = annDate.getFullYear();
        var contDiv: HTMLElement = document.createElement('div');
        var headerYearElem: HTMLElement = document.createElement('h2');
        headerYearElem.innerHTML = currentYear + "";
        tableElem = document.createElement('table');
        headerYearElem.addEventListener('click', ((t,h2) => () => {            
          that.toggleDisplay(t,h2);
        })(tableElem, headerYearElem));

        contDiv.appendChild(headerYearElem);
        contDiv.appendChild(tableElem);
        elem.appendChild(contDiv);

        if (tableCount > 1 || collapsed) {
          this.toggleDisplay(tableElem, headerYearElem);
        } else {
          headerYearElem.classList.add(this.activatedClassName);
        }
        
      }
      var trElem: HTMLElement = document.createElement('tr');
      var tdDate: HTMLElement = document.createElement('td');
      var mySimpleDateFormatter = new simpleDateFormat(dateFormat || 'dd MMM y', null);        
      tdDate.innerHTML = mySimpleDateFormatter.format(new Date(announcement.date.substring(0,10)));
      let tdLink: HTMLElement = document.createElement('td');
      tdLink.className = "investi-announcement-accordion-headline";
      tdLink.appendChild(this.getAnnLink(announcement));      
      trElem.appendChild(tdDate);
      
      if (showPriceSensitiveColumn) {
        var tdPriceSensitive: HTMLElement = document.createElement('td');
        tdPriceSensitive.innerHTML = announcement.priceSensitive ? "&#10004;" : "";
        trElem.appendChild(tdPriceSensitive);
      }
      trElem.appendChild(tdLink);
      
      tableElem.appendChild(trElem);
      rows.push(trElem)
      
    }
  
    const getTextFunc = (row:HTMLElement):string => row.querySelector<HTMLElement>(".investi-announcement-accordion-headline").innerText;
    
    if(elem.hasAttribute('data-investi-searchbox')){
      elem.prepend(this.createSearchBox(rows, {getTextFunc}));
    }
  }



  toggleDisplay(elem: HTMLElement, headerYearElem: HTMLElement) {
    
    if (elem.style.display === "none") {
      elem.style.display = "";
      headerYearElem.classList.add(this.activatedClassName);
    } else {      
      elem.style.display = "none";
      headerYearElem.classList.remove(this.activatedClassName);
    }

  }

  createCarousel(){

    this.doActionOnIdOrClass(AnnouncementsCarouselWidgetName, (elem, apiKey) => {

      this.getAnnouncementData(apiKey, announcements => {
        
        this.createCarouselInternal(elem, announcements);

      });
    });
    
  }

  createCarouselInternal(elem:HTMLElement, container:IApiKeyWrapper) {
    if(typeof jQuery == 'undefined'){
      console.error('investi: jquery required for Carousel')
      return;
    }
    
    if (typeof jQuery().slick !== "function"){
      console.error('investi: slick required for Carousel')
      return;
    }

            
    let announcements = container.announcements;
    if(this.checkSubscriptionExpired(elem, container))
      return;
    
    const dateFormat = elem.getAttribute('data-investi-date-format');        
    
    announcements = this.filterAnnouncements(elem, announcements);

    for (let j = 0; j < Math.min(9, announcements.length); j++) {

      var contDiv: HTMLElement = document.createElement('div');
      contDiv.classList.add('investi-carousel_announcement-container')

      var dateDiv: HTMLElement = document.createElement('div');
      dateDiv.classList.add('investi-carousel_announcement-date')
      var mySimpleDateFormatter = new simpleDateFormat(dateFormat || 'dd MMM y', null);        
      dateDiv.innerHTML = mySimpleDateFormatter.format(new Date(announcements[j].date.substring(0,10)));                    
      contDiv.appendChild(dateDiv);

      var headlineDiv: HTMLElement = document.createElement('div');
      headlineDiv.classList.add('investi-carousel_announcement-headline')
      headlineDiv.appendChild(this.getAnnLink(announcements[j]));          
      contDiv.appendChild(headlineDiv);

      elem.appendChild(contDiv);
    }
    
    jQuery(elem).slick(this.getCarouselOptions());
  }

  getCarouselOptions() {
    return {
      dots: true,
      infinite: false,
      speed: 300,   
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst:true,
      responsive: [
        {
          breakpoint: 1460,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },          
      ]
    }
  }

  createAnnouncementsThumbnail(){

    for(let widgetName of [ AnnouncementsLatestPresentationWidgetName, AnnouncementsReportsWidgetName, AnnouncementsThumbnailWidgetName  ]){
      this.doActionOnIdOrClass(widgetName, (elem, apiKey) => {

        this.getAnnouncementData(apiKey, announcements => {
          
          this.createAnnouncementsThumbnailInternal(elem, announcements, widgetName);
  
        });
      });
    }
    
    
  }

  createAnnouncementsThumbnailInternal(elem:HTMLElement, container:IApiKeyWrapper, widgetName:string) {


            
    if(this.checkSubscriptionExpired(elem, container))
      return;
    
      //data-investi-filter-regex=""
    
    const options = this.getAnnouncementFilterOptions(elem);    
    let width = +elem.getAttribute('data-investi-thumbnail-image-width');
    let height = +elem.getAttribute('data-investi-thumbnail-image-height');
    let numAnnouncements = parseInt(elem.getAttribute('data-investi-num-announcements'))
    if(!elem.classList.contains(AnnouncementsThumbnailWidgetName)){
      elem.classList.add(AnnouncementsThumbnailWidgetName)
    }

    if(widgetName===AnnouncementsLatestPresentationWidgetName){
      options.filterRegex = options.filterRegex || 'presentation'
      width = width || 450;
      height = height || 450;
      
    } else if(widgetName===AnnouncementsReportsWidgetName){
      options.filterRegex = options.filterRegex || 'annual.*report|quarterly.*report|half.*report';      
      numAnnouncements = numAnnouncements || 6;
    }    
    
    const announcements = this.filterAnnouncementsFromOptions(options, container.announcements);
    if(!numAnnouncements){
      numAnnouncements=1;
    }
    if(numAnnouncements === 1){
      elem.classList.add('data-investi-announcements-thumbnail-single-announcement-only')
    }
    width = width || 250;
    height = height || 250;
    
    const MaxNumThumbnails = 12;
    if(numAnnouncements > MaxNumThumbnails){
      console.warn(`cannot show more than ${MaxNumThumbnails} announcement thumbnails`)
      numAnnouncements = 12;
    }
    
    const dateFormat = this.getDateFormat(elem);

    if(announcements.length){
      
      const count = Math.min(announcements.length, numAnnouncements);
      for (let i = 0; i < count; i++) {
        const announcement = announcements[i];
        elem.append(this.getAnnouncementThumbnailElem(announcement, dateFormat, width, height));
      }
      
    }else{
      this.setNoDataMessage(elem, announcements);
    }
    
    
  }

  getAnnouncementThumbnailElem(announcement:Announcement, dateFormat:string, width:number|string, height:number|string){

    

    const anchorElem = this.getAnnLink(announcement);
    anchorElem.innerText = '';
    anchorElem.className = 'investi-announcements-thumbnail__anchor';      
    const div: HTMLDivElement = document.createElement('div');
    div.className = 'investi-announcements-thumbnail__header';

    {
      const img: HTMLImageElement = document.createElement('img');    
      let imgSrc = anchorElem.href.replace(/\.pdf$/, `_${width}x${height}.jpg`);
      img.src = imgSrc.replace("announcements", "announcementthumbnail");      
      anchorElem.append(img)
    }

    const headline = document.createElement('div');
    headline.className = 'investi-announcements-thumbnail__headline';
    headline.innerText = announcement.headline;
    div.appendChild(headline);    
    
    const dateFormatter = new simpleDateFormat(dateFormat || 'dd MMM yy', null);      
    const dateElem = document.createElement('div');
    dateElem.className = 'investi-announcements-thumbnail__date';
    dateElem.innerText = dateFormatter.format(new Date(announcement.date));
    div.appendChild(dateElem);

    
    
    anchorElem.append(div);

   
    
    return anchorElem
  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  

  doActionOnIdOrClass(idOrClassName:string, action:(elem:HTMLElement, apiKey:string)=>void){
    
    
    let elem: HTMLElement = document.getElementById(idOrClassName);
    let arr:HTMLElement[] = [];
    if (elem != null){
      arr.push(elem);
    }    
    for(let elem of Array.from(document.getElementsByClassName(idOrClassName))){
      arr.push(<HTMLElement>elem);      
    }
    for(let elem of arr){
      if(!elem.hasAttribute(WidgetCreatedAttrName)){
        action(elem, elem.getAttribute('apiKey'));
        elem.setAttribute(WidgetCreatedAttrName, '1');
      }else{
        console.warn(`elem ${idOrClassName} already created. are you referencing investi.js more than once?`)
      }
      
    }
  }

  createInvestiMarketDataIndividualFields(){
    
    for(let elemName of MarketDataElemNames){
      
      this.doActionOnIdOrClass(elemName, (elem, apiKey) => {
        this.getMarketData(apiKey, (container)=>{                
          const data = container.marketData;
          if(this.checkSubscriptionExpired(elem, container))
            return;
          if(elemName===SharePriceSymbolElementName){
            this.setSharePriceSymbol(elem, data);
          }else if(elemName===SharePriceMovement){
            this.setSharePriceMovement(elem, data);
          }else if(elemName===SharePriceLastElementName){
            this.setSharePriceLast(elem, data);
          }else if(elemName===SharePriceMovementPercent){
            this.setSharePriceMovementPercent(elem, data.movementPercent);
          }else if(elemName===ShareMarketCapName){
            this.setMarketCap(elem, data);
          }else if(elemName===SharesOnIssueName){
            this.setMarketDataFieldWithCommas(elem, data.sharesOnIssue);
          }else if(elemName===SharePriceVolumeElementName){
            this.setMarketDataFieldWithCommas(elem, data.volume);
          }else if(elemName===SharePriceUpdateTime){            
            this.setDateField(elem, data.updated, () => this.formatAMPM(new Date(data.updated)));            
          }else if(elemName===SharePriceUpdateDate){           
            this.setDateField(elem, data.updated, () => this.formatDateOnly(new Date(data.updated)));            
          }else if(elemName===SharePriceUpdated){
            this.setDateField(elem, data.updated, () => this.formatAMPM(new Date(data.updated)) + " " + this.formatDateOnly(new Date(data.updated)));            
          }else{
            this.setMarketDataField(elem, data, elemName);
          }
          
          
        })      
      });
    }
    
  }

  setDateField(elem:HTMLElement, updated:string, defaultFormatting:()=>string){
    const dateFormatAttr = this.getDateFormat(elem);
    if(dateFormatAttr){
      const dateFormatter = new simpleDateFormat(dateFormatAttr, null);
      elem.innerHTML = dateFormatter.format(updated);
    }else{
      elem.innerHTML = defaultFormatting();
    }
  }

  setSharePriceLast(elem:HTMLElement, data:StockMarketData){
    const hasPrefix = elem.hasAttribute('data-investi-prefix-currency-symbol');
    elem.innerHTML = (hasPrefix ? this.getCurrencySymbolPrefix(data):'') + this.addZeroes(data.last, elem);    
  }

  setMarketDataField(elem:HTMLElement, data:StockMarketData, elemName:string){
    const tokens = elemName.split('-');
    const fieldName = tokens[tokens.length-1];  
         
    if(data.hasOwnProperty(fieldName)){
      
      let fieldValue = this.getFormattedMarketDataNumericField(data[fieldName], elem);      
      elem.innerHTML = this.getCurrencySymbolPrefix(data) + fieldValue;
    }else{
      console.warn(`unknown marketData proprety ${elemName}`)
    }
  }

  getCurrencySymbolPrefix(data:StockMarketData) : string{
    return `<span class="investi-currency-symbol">${this.getDollarSign(data.currency)}</span>`;
  }

  getFormattedMarketDataNumericField(fieldValue:any, elem:HTMLElement){
    const attrVal = elem.getAttribute('investi-num-decimal-places');
    
    const numDecimalPlaces = parseInt(attrVal) || 2;
    const parsedFloat = parseFloat(fieldValue); 
    if(!isNaN(parsedFloat)){
      if(attrVal){        
        
        fieldValue = fieldValue.toFixed(numDecimalPlaces);//format explicitly defined
      }else{
        fieldValue = this.formatNumber(parsedFloat, numDecimalPlaces);
      }
      
    }
    return fieldValue;
  }

  formatNumber(num:number, dp:number):string {
    // Convert the number to a string and split it into integer and decimal parts
    const [integerPart, decimalPart] = num.toString().split('.');

    // Check if there's a decimal part and its length
    if (decimalPart && decimalPart.length > 2) {
        // If more than two decimal places, return the number as is with its original decimal part
        return integerPart + '.' + decimalPart;
    } else {
        // If two or fewer decimal places, use toFixed(2)
        return num.toFixed(dp);
    }
}

  setSharePriceSymbol(elem:HTMLElement, marketData:StockMarketData){
    elem.innerHTML = `${marketData.exchange}:${marketData.ticker}`;
  }

  createSecFilingsWidget(){
    
    this.doActionOnIdOrClass(SecFilingsWidgetName, (elem, apiKey) => {
      const container = this.ensureContainer(apiKey);

      this.sendRequest('/api/secFilings', apiKey,
      json => {
        
        this.setContainerField(container, json, x =>container.secFilingResult = x)
        
        if(this.checkSubscriptionExpired(elem, container))
          return;

        const onSelectChanged = () => {
          this.createSecFilingsTable(apiKey, elem);
        }
        elem.appendChild(this.getSecFilingsFilter(onSelectChanged));
       
        onSelectChanged();
        
      }); 
    });       
  }

  createSecFilingsTable(apiKey:string, elem:HTMLElement) {

    const filterElem = document.getElementsByClassName('investi-sec-filings__filter-select').item(0) as HTMLSelectElement;
    
    const container = this.ensureContainer(apiKey);
    const dateFormat = this.getDateFormat(elem);
    const dateFormatter = new simpleDateFormat(dateFormat || 'dd MMM yyyy', null);
    let currentYear = -1;
    let tableCount = 0;
    let tableElem: HTMLTableElement;
    const that = this;
    const containerClassname = 'investi-sec-filings__table-container'
    const elements = document.getElementsByClassName(containerClassname);
    while(elements.length > 0){
        elements[0].parentNode.removeChild(elements[0]);
    }

    for(let filing of container.secFilingResult?.secFilings){
      
      const formTypes = filterElem.value.split(',');
      
      if(!filterElem.value || formTypes.includes(filing.form)){
        
        const date = new Date(filing.date);
      
      if (date.getFullYear() != currentYear) {
        tableCount++;
        
        currentYear = date.getFullYear();
        var contDiv: HTMLElement = document.createElement('div');
        contDiv.className = containerClassname;
        var headerYearElem: HTMLElement = document.createElement('h2');
        headerYearElem.innerHTML = currentYear + "";
        tableElem = this.createSecFilingsWidgetTable();
        headerYearElem.addEventListener('click', ((t,h2) => () => {            
          that.toggleDisplay(t,h2);
        })(tableElem, headerYearElem));

        contDiv.appendChild(headerYearElem);
        contDiv.appendChild(tableElem);
        elem.appendChild(contDiv);

        if (tableCount > 1) {
          this.toggleDisplay(tableElem, headerYearElem);
        } else {
          headerYearElem.classList.add(this.activatedClassName);
        }
        
      }
      this.createSecFilingsWidgetTableRow(filing, dateFormatter.format(date), tableElem)
      }
      
      
      
    }
  }

  // getFormTypes(selectText:string) : string[]{
  //   if(selectText == "Quarterly Filings"){
  //     return [ "10-Q"]
  //   }
  //   else if(selectText == "Annual Filings"){
  //     return [ "10-K"]
  //   }
  //   else if(selectText == "Current Reports"){
  //     return [ "8-K"]
  //   }
  //   else if(selectText == "Proxy Filings"){
  //     return [ "DEFA14A", "DEF 14A"]
  //   }
  //   else if(selectText == "	SEC Staff Action"){
  //     return [ "SEC STAFF ACTION"]
  //   }
  //   else if(selectText == "Statement of beneficial ownership of securities"){
  //     return [ "3"]
  //   }
  //   return [];
  // }

  getSecFilingsFilter(onSelectChanged:()=>void) : HTMLElement {
        
    const span = document.createElement('span');
    span.className = "investi-sec-filings__filter-label"
    span.innerText = "Filter filing type:"
    
    const select = document.createElement('select');
    select.className = "investi-sec-filings__filter-select"

    select.appendChild(this.getSecFilingSelectFilterOption("All Form Types", ""));
    select.appendChild(this.getSecFilingSelectFilterOption("Annual Filings", "10-K"));
    select.appendChild(this.getSecFilingSelectFilterOption("Quarterly Filings", "10-Q"));
    select.appendChild(this.getSecFilingSelectFilterOption("Current Reports", "8-K"));
    select.appendChild(this.getSecFilingSelectFilterOption("Proxy Filings", "DEFA14A,DEF 14A"));
    select.appendChild(this.getSecFilingSelectFilterOption("SEC Staff Action", "SEC STAFF ACTION"));
    select.appendChild(this.getSecFilingSelectFilterOption("Statement of beneficial ownership of securities", "3"));
    //select.appendChild(this.getSecFilingSelectFilterOption("zzz", "zzz"));
    select.addEventListener('change', (event) => {
      
      onSelectChanged();
    });

    const contDiv = document.createElement('div');
    contDiv.className = "investi-sec-filings__filter-container"
    contDiv.appendChild(span);
    contDiv.appendChild(select);
    /*
    <select class="dropdown module_options-select module-sec_type-select" id="SecFilingType">
        <option selected="selected" value="">All Form Types</option>
        <option value="1,4">Annual Filings</option>
        <option value="2">Quarterly Filings</option>
        <option value="9,40">Current Reports</option>
        <option value="11,17">Proxy Filings</option>
        <option value="41">Registration Statements</option>
        <option value="13">Section 16 Filings</option>
        <option value="3,20,21,30,33,34,35,36,37,42">Other</option>
    </select>
    */
   return contDiv;
  }

  getSecFilingSelectFilterOption(text:string, value:string|undefined) : HTMLOptionElement {
    const option = document.createElement('option');
    option.innerText = text;
    option.value = value;
    return option;
  }

  createSecFilingsWidgetTable(): HTMLTableElement{

    const table = document.createElement('table');
    const thead = document.createElement('thead');
    thead.innerHTML = "<tr><th>Date</th><th>Form</th><th>Description</th><th>Download</th></tr>";
    const tbody = document.createElement('tbody');
    table.appendChild(thead);
    table.appendChild(tbody);
    
    return table;
  }

  createSecFilingsWidgetTableRow(filing:SecFiling, date:string, table:HTMLTableElement){
    const tbody = table.querySelector<HTMLTableSectionElement>('tbody');    
    const tr: HTMLElement = document.createElement('tr');
    
    const dateTd = document.createElement('td');
    
    dateTd.innerHTML = date;        
    tr.appendChild(dateTd);

    const formTd = document.createElement('td');
    formTd.innerHTML = filing.form;
    tr.appendChild(formTd);

    const descriptionTd = document.createElement('td');
    descriptionTd.innerHTML = filing.description;
    tr.appendChild(descriptionTd);

    const download: HTMLElement = document.createElement('td');
    for(let file of filing.files){
      
      const span = document.createElement('span');
      download.appendChild(span); 
      let fileTypeCss = 'fiv-icon-blank';
      if(file.secFilingDocumentType == SecFilingDocumentType.Html){
        fileTypeCss ="fiv-icon-html";
      }else if(file.secFilingDocumentType == SecFilingDocumentType.Pdf){
        fileTypeCss ="fiv-icon-pdf";
      }
      else if(file.secFilingDocumentType == SecFilingDocumentType.Xml){
        fileTypeCss ="fiv-icon-xml";
      }
      else if(file.secFilingDocumentType == SecFilingDocumentType.Zip){
        fileTypeCss ="fiv-icon-zip";
      }
      span.className = `fiv-cla fiv-size-md ${fileTypeCss}`;
      const anchor: HTMLAnchorElement = <HTMLAnchorElement>document.createElement('a');          
      const url = (file.url.startsWith('/api/') ? this.baseAddress : '') + file.url;            
      anchor.href = url;    
      anchor.target = "_blank";
      // anchor.innerText = "html";
      anchor.appendChild(span);
      download.appendChild(anchor);
    }

    tr.appendChild(download);
    tbody.appendChild(tr);
  }


    

  create() {
    this.createInvestiSharePriceWidget();
    this.createInvestiSharePriceTable();
    this.createInvestiMarketDataIndividualFields();
    this.createInvestiChart();
    this.createInvestiAnnouncementTable();
    this.createInvestiAnnouncementsInteractiveTable();
    this.createInvestiAnnouncementSummary();
    this.createInvestiHeaderWidget();
    this.createinvestiPriceOnTopWidget();
    this.createHeaderPrice();
    this.createInvestiAnnouncementAccordion();
    this.createCarousel();
    this.createAnnouncementsThumbnail();
    this.createInvestiAnnouncementSummary_v2();
    this.createInvestiAnnouncementTab();
    this.createSecFilingsWidget();
  }

  start(){
    
    let promises:Promise<void>[] = [];    
    if(widget.shouldPollMarketData()){      
      promises = widget.apiKeys.map(x => {
        return new Promise<void>((resolve, reject) =>{
          widget.getMarketData(x.apiKey, data => resolve(), err => resolve())
        });
      });      
    }

    if(widget.hasAnnouncementWidget()){
      promises.push(...widget.apiKeys.map(x => {
        return new Promise<void>((resolve, reject) =>{
          widget.getAnnouncementData(x.apiKey,data => resolve(), err => resolve())
        });
      }));      
    }
    
    
    Promise.all(promises).then(()=>{
      widget.create();
    }).catch(console.error);
  }

};

class PdfViewer{

  pdfDoc:any = null;
  pageNum:number = 1;
  pageRendering:boolean = false;
  pageNumPending:any = null;
  canvas:HTMLCanvasElement;    
  ctx:CanvasRenderingContext2D
  elem:HTMLElement
  pageCountElem:HTMLElement
  pageNumElem:HTMLElement
  loadingElem:HTMLElement
  canvasHeader:HTMLElement
  infoElem:HTMLElement
  errorLoadingElem:HTMLAnchorElement
  announcementLink:HTMLAnchorElement
  announcementHeadline:HTMLElement
  hide:boolean;

  constructor(elem:HTMLElement){
    this.elem = elem;
    this.hide = elem.hasAttribute('data-investi-interactive-announcements-hide-pdf-viewer');
    this.canvas = elem.querySelector('.investi-pdf-canvas') as HTMLCanvasElement;
    this.ctx = this.canvas.getContext('2d');
    (elem.querySelector('.investi-pdf-prev-page-btn') as HTMLElement).onclick = this.onPrevPage.bind(this);
    (elem.querySelector('.investi-pdf-next-page-btn') as HTMLElement).onclick = this.onNextPage.bind(this);
    this.pageCountElem = this.elem.querySelector('.investi-pdf-page-count');
    this.pageNumElem = this.elem.querySelector('.investi-pdf-page-num');
    this.loadingElem = this.elem.querySelector('.investi-loading');
    this.canvasHeader = this.elem.querySelector('.investi-pdf-buttons');
    this.infoElem = this.elem.querySelector('.investi-pdf-info');
    this.errorLoadingElem = this.elem.querySelector('.investi-pdf-error-loading');
    this.announcementLink = this.elem.querySelector('.investi-pdf-announcement-link') as HTMLAnchorElement;
    this.announcementHeadline = this.elem.querySelector('.investi-pdf-info-announcement-headline') as HTMLElement;
  }
  queueRenderPage(num) {
    if (this.pageRendering) {
      this.pageNumPending = num;
    } else {
      this.renderPage(num);
    }
  }

  renderPage(num) {
    this.pageRendering = true;
    
    // Using promise to fetch the page
    this.pdfDoc.getPage(num).then((page) =>{
      
      // const scale = window.screen.width >= 1920 ? 2 : 1;
      const scale = 2;
      let viewport = page.getViewport({ scale });  
      
      // var container = document.getElementsByClassName('investi-pdf-canvas-container')[0];
      // console.log('container.clientWidth', container.clientWidth)
      // var scale = container.clientWidth / viewport.width;
      // viewport = page.getViewport(scale);    

      this.canvas.height = viewport.height;
      this.canvas.width = viewport.width;
      
      // Render PDF page into canvas context
      const renderContext = {
        canvasContext: this.ctx,
        viewport: viewport
      };
      const renderTask = page.render(renderContext);

      // Wait for rendering to finish
      renderTask.promise.then(()=> {
        this.pageRendering = false;
        this.loadingElem.style.display = 'none';
        if (this.pageNumPending !== null) {
          // New page rendering is pending
          this.renderPage(this.pageNumPending);
          this.pageNumPending = null;
        }
      });
    });

    // Update page counters
    this.pageNumElem.textContent = num;
  }

  onPrevPage() {
    if (this.pageNum <= 1) {
      return;
    }
    this.pageNum--;
    this.queueRenderPage(this.pageNum);
  }



  onNextPage() {
    if (this.pageNum >= this.pdfDoc.numPages) {
      return;
    }
    this.pageNum++;
    this.queueRenderPage(this.pageNum);
  }
      
  setPdfInfo(info:HTMLElement, announcement:Announcement,href:string):void{
    this.announcementHeadline.innerText = announcement.headline;
    this.announcementLink.href = href;
    
  }
  async setPdf(announcement:Announcement, href:string){
    this.setPdfInfo(this.infoElem, announcement, href);
    
    this.errorLoadingElem.style.display = 'none';
    this.canvasHeader.style.visibility = "hidden"
    this.canvas.style.visibility = "hidden"
    this.pageNum = 1;
    if(!this.hide){
      this.loadingElem.style.display = 'initial';
      const pdfjsLib = globalThis.pdfjsLib;    
      pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.2.67/pdf.worker.min.mjs';
      try {        
        const pdfDoc_ = await (pdfjsLib.getDocument(href).promise);
        this.pdfDoc = pdfDoc_;  
        this.pageCountElem.textContent = this.pdfDoc.numPages;
        this.canvas.style.visibility = "visible"
        this.canvasHeader.style.visibility = "visible"
        this.renderPage(this.pageNum);
      } catch (e) {
        console.error(e)
        this.loadingElem.style.display = 'none';
        this.errorLoadingElem.style.display = 'block';
      }
      
    }else{
      this.canvasHeader.style.display = "none"
      this.canvas.style.display = "none"
    }
            
  }
}


const widget = new InvestiWidget();
widget.start();
// Attach it to the window object for global access
(window as any).investi_widget = widget;